export const courses = {
  edges: [
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2VkMDM=',
        title: ' BES 123: Learning and Teaching ',
        url: '/nd2_nou20_ed03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Gaurav Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-30T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ed03/learning_and_teaching.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2VkMDQ=',
        title: ' BES 141: Pedagogy of Science',
        url: '/nd2_nou20_ed04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Gaurav Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-30T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ed04/padagogy.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University ',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xiMDk=',
        title: ' BLI- 011:  Libraries: An introduction',
        url: '/nd2_nou20_lb09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Archna Shukla',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lb09/10. Libraries An introduction.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xiMTA=',
        title: ' BLII- 104: ICT in Libraries',
        url: '/nd2_nou20_lb10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor Uma Kanjilal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lb10/11. Computer Applications in Libraries.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2FnMTY=',
        title: ' Cooperatives and Farmers\u2019 Organizations (MNRE015)',
        url: '/nd2_nou20_ag16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Praveen Kumar Jain',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-31T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ag16/MNRE-15-Course-Image.jpg',
        credits: 4,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjU=',
        title: ' Development of Self Learning Material',
        url: '/nd2_ntr20_ed25/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sunil Dutt',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-15T08:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed25/Logo sd.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Chandigarh.',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2FnMTA=',
        title: ' Indian Agricultural Development (MNR 001)',
        url: '/nd2_nou20_ag10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Praveen Kumar Jain',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-31T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ag03/agriculture_960_600.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2dlMDU=',
        title: ' MSD-011 Sustainability Science',
        url: '/nd2_nou20_ge05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Y.S.C. Khuman',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '2020-11-14T17:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ge05/sustainability.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2dlMDQ=',
        title: ' OVAL-005: Study from Still Life',
        url: '/nd2_nou20_ge04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Lakshaman Prasad ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ge04/Study from Still Life.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University ',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2FnMTc=',
        title: ' Project Analysis (MNRE 016)',
        url: '/nd2_nou20_ag17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Praveen Kumar Jain',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-31T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ag17/MNRE-16-Project-Analysis_Course_Image.jpg',
        credits: 4,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzk=',
        title: 'A basic course in number theory',
        url: '/nd1_noc20_ma39/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Shripad Garge',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_ma04/BBM.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMzA=',
        title: 'Academic \u0026 Research Report Writing ',
        url: '/nd2_ntr20_ed30/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Samir Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-15T08:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed30/ARRW.gif',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research , Kolkata',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjk=',
        title: 'Academic Writing ',
        url: '/nd2_cec20_ge29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Ajay Semalty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T19:00:00.000000Z',
        endDate: '2020-11-30T18:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-30T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ugc19_ge03/Untitled.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'HNB Garhwal University (A Central University) Srinagar Garhwal (Uttarakhand)',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjY=',
        title: 'Access to Justice',
        url: '/nd2_cec20_mg26/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Bharti Yadav',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-01T03:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '2020-11-14T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs25/justice.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'National Law University Delhi',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMDI=',
        title: 'Accountancy XI Part-I',
        url: '/nd2_nce19_sc02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shipra Vaidya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T18:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc02/Accountancy_01_2020.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTIwX3NjMDY=',
        title: 'Accountancy XII Part -1',
        url: '/nd2_nce20_sc06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shipra Vaidya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T19:30:00.000000Z',
        endDate: '2020-10-29T17:30:00.000000Z',
        examDate: '2020-10-15T17:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce20_sc06/ Accountancy XII Part-01.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjg=',
        title: 'Accreditation for Diploma Engineering Programmes July 2020',
        url: '/nd2_ntr20_ed28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Badrilal Gupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-28T17:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed28/For ADEP.jpg',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Bhopal',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMzI=',
        title: 'Accreditation of Undergraduate Engineering Programmes.',
        url: '/nd2_ntr20_ed32/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. R.K.Dixit, Prof. Sanjay Agrawal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-28T17:30:00.000000Z',
        examDate: '2020-11-15T08:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed32/ACUG _ BHp.jpg',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Bhopal  ',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMDc=',
        title: 'Advance Aircraft Maintenance',
        url: '/nd1_noc20_ae07/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. A.K. Ghosh, Prof. Vipul Mathur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AERO_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ae02.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDE=',
        title: 'Advanced C++',
        url: '/nd2_aic20_sp01/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-01T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp01/Advanced-CPP.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDU=',
        title: 'Advanced Concrete Technology',
        url: '/nd1_noc20_ce45/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Manu Santhanam',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_13', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjc=',
        title: 'Advanced Constitutional Law',
        url: '/nd2_cec20_mg27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Anupama Goel',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-31T18:30:00.000000Z',
        endDate: '2020-12-30T18:30:00.000000Z',
        examDate: '2020-12-06T20:30:00.000000Z',
        enrollmentEndDate: '2020-09-30T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          ' https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg27/resize advance constitutional law.png?seed=93680\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg27/resize advance constitutional law.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'National Law University Delhi',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDU=',
        title: 'Advanced Corporate Strategy',
        url: '/nd2_imb20_mg45/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. R. Srinivasan and Prof. Sai Yayavaram',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg45/ACS_Banner_Image_Final.PNG',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTQ=',
        title: 'Advanced Fluid Mechanics',
        url: '/nd1_noc20_me54/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Suman Chakraborty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_12', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzY=',
        title: 'Advanced Machining Processes',
        url: '/nd1_noc20_me76/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Manas Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMTk=',
        title: 'Advanced Materials and Processes',
        url: '/nd1_noc20_mm19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Jayanta Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'METALLURGY_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Metallurgy%20and%20Material%20Science/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjc=',
        title: 'Advances in UHV Transmission and Distribution',
        url: '/nd1_noc20_ee67/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Subbba Reddy B',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjU=',
        title: 'Advances in welding and joining technologies',
        url: '/nd1_noc20_me65/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Swarup Bag',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_26', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2FnMTU=',
        title:
          'Agricultural Policy: Formulation, Components, Process, Implementation and Comparative Analysis (MNR-002)',
        url: '/nd2_nou20_ag15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Praveen Kumar Jain',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-31T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ag15/MNR-002-Agricultural Policy_Course_Image.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lOTA=',
        title: 'Aircraft Propulsion',
        url: '/nd1_noc20_me90/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Vinayak N. Kulkarni',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_37', category: null },
          { name: 'Domain_18', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMDU=',
        title: 'Aircraft Stability and Control',
        url: '/nd1_noc20_ae05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. A.K. Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'AERO_COURSES', category: null },
          { name: 'Domain_22', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Aerospace%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMDg=',
        title: 'Aircraft Structures - I',
        url: '/nd1_noc20_ae08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anup Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AERO_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ae02.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMjU=',
        title: 'Algebra - I',
        url: '/nd1_noc20_ma25/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. S. Viswanath, Prof. Amritanshu Prasad',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_ma04/BBM.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IMSc',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTQ=',
        title: 'An Introduction to Coding Theory',
        url: '/nd1_noc20_ee94/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Adrish Banerjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_7', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODk=',
        title: 'Analog Electronic Circuit',
        url: '/nd1_noc20_ee89/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shouribrata chatterjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_14', category: null },
          { name: 'Domain_41', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjk=',
        title: 'Analog communication',
        url: '/nd1_noc20_ee69/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Goutam Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MjI=',
        title: 'Analytical Techniques',
        url: '/nd2_cec20_bt22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. M.R Rajeswari',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T18:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ugc19_bt16/bioch.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Biochemistry, All India Institute of Medical Sciences, New Delhi',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MTg=',
        title: 'Analytical chemistry',
        url: '/nd1_noc20_cy18/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debashis Ray',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDI=',
        title: 'Android app using Kotlin',
        url: '/nd2_aic20_sp02/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp02/Android-app-using-Kotlin.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0NDI=',
        title: 'Animal Physiology',
        url: '/nd1_noc20_bt42/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mainak Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MjM=',
        title:
          'Application of Spectroscopic Methods in Molecular Structure Determination',
        url: '/nd1_noc20_cy23/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Sankararaman',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDM=',
        title: 'Applications of GeoGebra',
        url: '/nd2_aic20_sp03/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-13T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp03/Application of Geogebra.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTM=',
        title: 'Applied Electromagnetics For Engineers',
        url: '/nd1_noc20_ee93/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Pradeep Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_33', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTE=',
        title: 'Applied Linguistics',
        url: '/nd1_noc20_hs51/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajesh Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMTc=',
        title: 'Applied Multivariate Analysis',
        url: '/nd2_cec20_ma17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Sugata Sen Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-13T00:00:00.000000Z',
        endDate: '2020-10-25T00:00:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 3,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'University of Calcutta',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODc=',
        title: 'Applied Natural Language Processing',
        url: '/nd1_noc20_cs87/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ramaseshan R',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'CMI',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNTk=',
        title: 'Applied Optimization for Wireless, Machine Learning, Big Data',
        url: '/nd1_noc20_ee59/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Aditya K. Jagannatham',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjM=',
        title: 'Applied and Economic Zoology',
        url: '/nd2_cec20_ge23/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dalie Dominic A',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-21T18:30:00.000000Z',
        endDate: '2020-09-10T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge23/Applied and Economic Zoology.JPG',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'St.Mary\u0027s College, Thrissur',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzOTA=',
        title: 'Appreciating Carnatic Music',
        url: '/nd1_noc20_hs90/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Lakshmi Sreeram',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_hs90/Music.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNjk=',
        title: 'Appreciating Linguistics: A typological approach',
        url: '/nd1_noc20_hs69/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anindita',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjQ=',
        title: 'Aqueous Corrosion and Its Control',
        url: '/nd1_noc20_mm24/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. V. S. Raja',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'METALLURGY_COURSES', category: null },
          { name: 'Domain_26', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mm01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMDc=',
        title: 'Architectural Acoustics',
        url: '/nd1_noc20_ar07/preview',
        explorerSummary: '\n',
        explorerInstructorName:
          'Prof. Sumana Gupta, Prof. Shankha Pratim Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Architecture%20and%20Planning/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDQ=',
        title: 'Arduino',
        url: '/nd2_aic20_sp04/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-13T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'ELEC_ENGG', category: null },
          { name: 'Multidisciplinary', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp04/Arduino (1).png',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODE=',
        title: 'Artificial Intelligence Search Methods For Problem Solving',
        url: '/nd1_noc20_cs81/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Deepak Khemani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTg=',
        title: 'Automation in Manufacturing',
        url: '/nd1_noc20_me58/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shrikrishna N. Joshi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_24', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me07.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMDY=',
        title: 'BAL-001: Basics Of Arabic',
        url: '/nd2_nou20_hs06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Mohammad Saleem',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T19:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs06/BAL-001_Course_Image.jpg',
        credits: 8,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMDk=',
        title: 'BAL-002: Communication Skills',
        url: '/nd2_nou20_hs09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Mohammad Saleem',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T19:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou19_hs09/communication skill (Basic Arabic).jpg',
        credits: 8,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NtMDM=',
        title: 'BCOC-131- Financial Accounting\u00a0',
        url: '/nd2_nou20_cm03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sunil Kumar ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Commerce', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cm03/financial.jpg',
        credits: 6,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2dlMDI=',
        title: 'BHC-012:\u00a0Event\u00a0Planning ',
        url: '/nd2_nou20_ge02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Heena K. Bijli',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ge02/event_planning.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University ',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2dlMDM=',
        title: 'BHC-013:\u00a0Event\u00a0Coordination and Control',
        url: '/nd2_nou20_ge03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Heena K. Bijli',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ge03/event_coordinate_control.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University ',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX21nMDE=',
        title: 'BMS001: Introduction to NGO Management',
        url: '/nd2_nou20_mg01/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Neeti Agrawal \u0026 Prof Nayantara Padhi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-01T06:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_mg01/cover.JPG',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTY=',
        title: 'BSW-41: Understanding Tribals',
        url: '/nd2_nou20_hs16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. N.Ramya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs16/BSW-41.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTc=',
        title: 'BSW-42: Tribal Society',
        url: '/nd2_nou20_hs17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Saumya \u0026 Dr. Sayantani Guin',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs17/BSW-42.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTg=',
        title: 'BSW-43:Tribals of South and Central India',
        url: '/nd2_nou20_hs18/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. G. Mahesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs18/BSW-43.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTk=',
        title: 'BSW-44:Tribals in North and Northeast Region of India',
        url: '/nd2_nou20_hs19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rose Nembiakkim',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs19/BSW-44.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nMzc=',
        title: 'Bandit Algorithm (Online Machine Learning)',
        url: '/nd1_noc20_mg37/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Manjesh hanawal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg03.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDA=',
        title: 'Banking and Financial Markets:A Risk Management Perspective.',
        url: '/nd2_imb20_mg40/preview',
        explorerSummary: '',
        explorerInstructorName: 'P C Narayan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T06:00:00.000000Z',
        endDate: '2020-10-30T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg40/Banking and Financial Markets A Risk Managent Perspectives V1.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzU=',
        title: 'Basic Econometrics',
        url: '/nd2_cec20_hs35/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr.Pradip Prajapati',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-09-27T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs35/WhatsApp Image 2020-05-20 at 8.01.19 PM.jpeg',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Economics, Gujarat University, Ahmedabad.',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjQ=',
        title: 'Basic Electrical Circuits',
        url: '/nd1_noc20_ee64/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Nagendra Krishnapura',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_14', category: null },
          { name: 'Domain_34', category: null },
          { name: 'Domain_41', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5Mjg=',
        title: 'Basic Statistical Mechanics',
        url: '/nd1_noc20_cy28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Biman Bagchi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cy02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lOTE=',
        title: 'Basics Of Finite Element Analysis-I',
        url: '/nd1_noc20_me91/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nachiketa Tiwari        ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_2', category: null },
          { name: 'Domain_10', category: null },
          { name: 'Domain_11', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTU=',
        title: 'Basics of Digital Marketing',
        url: '/nd2_cec20_mg15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Lalit Engle',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-17T19:00:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '2020-08-31T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_mg23/250x90.jpg?seed=84996\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_mg23/250x90.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Devi Ahilya Vishwavidyalaya, Indore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzNDM=',
        title: 'Basics of Macro Economics',
        url: '/nd2_cec20_hs43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Meeta Nihalani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T18:30:00.000000Z',
        endDate: '2020-10-07T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Jai Narain Vyas University Jodhpur',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzg=',
        title: 'Basics of Materials Engineering',
        url: '/nd1_noc20_me78/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ratna Kumar Annabattula',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_35', category: null },
          { name: 'Domain_2', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me07.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMDQ=',
        title: 'Basics of Russian: ORU-001: Communication Skills-I',
        url: '/nd2_nou20_hs04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Mr. Shivaji Bhaskar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-01T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs04/Shivaji_Course_Image.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMDU=',
        title: 'Basics of Russian: ORUL-002:Communication Skills-II',
        url: '/nd2_nou20_hs05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Mr. Shivaji Bhaskar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-01T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs05/Shivaji_Course_Image.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODc=',
        title: 'Basics of software defined Radios and Practical Applications',
        url: '/nd1_noc20_ee87/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Meenakshi Rawat',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2JldGFfdGVzdGNvdXJzZTEw',
        title: 'Beta Test Course 10: Example S\u0026T course',
        url: '/nd2_beta_testcourse10/preview',
        explorerSummary:
          '\u003Cdiv class="yui-wk-div"\u003E\u003Cdiv class="yui-wk-div"\u003EDepartment Of Civil Engineering\u003C/div\u003E\u003Cdiv class="yui-wk-div"\u003EIndian Institute of Technology Madras\u003C/div\u003E\u003C/div\u003E',
        explorerInstructorName:
          'Prof. Ravindra Gettu \u0026 Prof. Manu Santhanam',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: false,
        startDate: '2020-03-01T12:00:00.000000Z',
        endDate: '2020-11-12T00:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Engineering', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/beta_testcourse1/1.jpg',
        credits: 4,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'IIT MADRAS',
        ncCode: 'UGC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzOTI=',
        title: 'Big Data Computing',
        url: '/nd1_noc20_cs92/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Rajiv Misra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Patna',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lOTM=',
        title: 'BioMEMS And Microfluidics',
        url: '/nd1_noc20_me93/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shantanu Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MTI=',
        title: 'Biochemistry\u00a0 of Biomolecules',
        url: '/nd2_cec20_bt12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sudeshna Shyam Choudhury',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T18:30:00.000000Z',
        endDate: '2020-08-20T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt12/bg.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'St. Xavier\u0027s College (Autonomous), Kolkata',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzE=',
        title: 'Biogeography ',
        url: '/nd2_cec20_hs31/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. P.T. BHARATHI',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs31/BIOGEOGRAPHY.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Geography Maharajas College, University of Mysore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTI=',
        title: 'Biology XI Part-I',
        url: '/nd2_nce19_sc12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sunita Farkya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc12/bio01may2020.jpg',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTM=',
        title: 'Biology XI Part-II',
        url: '/nd2_nce19_sc13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sunita Farkya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc13/bio 02 image.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTQ=',
        title: 'Biology XII Part-I',
        url: '/nd2_nce19_sc14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. C.V. Shimray',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc14/bio XII part 1.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MjQ=',
        title: 'Biomass Characterization',
        url: '/nd2_cec20_bt24/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof.(Dr.) K. Arunkumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T04:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T09:00:00.000000Z',
        enrollmentEndDate: '2020-09-30T12:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt24/biomass.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Central University of Kerala',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0Mjk=',
        title: 'Biomedical nanotechnology',
        url: '/nd1_noc20_bt29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. P. Gopinath',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-10-08T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_4', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MjI=',
        title: 'Biomicrofluidics',
        url: '/nd1_noc20_bt22/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Tapas Kumar Maiti, Prof. Suman Chakraborty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-10-08T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_4', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MzM=',
        title: 'Biophysical chemistry',
        url: '/nd1_noc20_cy33/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Pramit Kumar Chowdhury',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MjY=',
        title: 'Bioreactors',
        url: '/nd1_noc20_bt26/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Suraishkumar G K',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MjM=',
        title: 'Biostatistics and Mathematical Biology',
        url: '/nd2_cec20_bt23/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Felix Bast',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T19:00:00.000000Z',
        endDate: '2020-10-10T18:00:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt23/felix.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Central University of Punjab, Bathinda',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNzE=',
        title: 'Body language: Key to professional Success',
        url: '/nd1_noc20_hs71/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rashmi Gaur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMDQ=',
        title: 'Building Materials and Composites',
        url: '/nd1_noc20_ar04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sumana Gupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ARCHI_COURSES', category: null },
          { name: 'Domain_13', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ar01.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMTE=',
        title: 'Building cost estimation simplified',
        url: '/nd2_nou20_cs11/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shruti Samuel',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs11/cover.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDc=',
        title: 'Business Analytics \u0026 Data Mining Modeling Using R Part II',
        url: '/nd1_noc20_mg47/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Gaurav Dixit',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjY=',
        title: 'Business Analytics \u0026 Text Mining Modeling Using Python',
        url: '/nd1_noc20_mg66/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Gaurav Dixit',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMzI=',
        title: 'Business Ethics',
        url: '/nd2_cec20_mg32/preview',
        explorerSummary: '',
        explorerInstructorName: 'Archana Vechalekar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T06:30:00.000000Z',
        endDate: '2020-09-13T17:30:00.000000Z',
        examDate: '2020-11-15T04:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg32/Business Ethics-course Image.png',
        credits: 4,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Savitribai Phule Pune University, Pune',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTQ=',
        title: 'Business Research Methods',
        url: '/nd2_cec20_mg14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr G Parameshwari',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T19:30:00.000000Z',
        endDate: '2020-11-15T17:30:00.000000Z',
        examDate: '2020-11-29T04:30:00.000000Z',
        enrollmentEndDate: '2020-09-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg14/Business Research Method course image.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Commerce,  PES College of Science Arts and Commerce, Mandya, Karnataka',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTM=',
        title: 'Business Statistics',
        url: '/nd2_cec20_mg13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Manju S',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T19:30:00.000000Z',
        endDate: '2020-09-13T17:30:00.000000Z',
        examDate: '2020-11-14T04:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg13/Business  Statistics course image.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          ' Maharani\u2019s Women\u2019s Commerce and Management College, Mysore-570020',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTIwX3NjMDc=',
        title: 'Business Studies XI Part-I',
        url: '/nd2_nce20_sc07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Punnam Veeraiah',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T19:30:00.000000Z',
        endDate: '2020-10-29T17:30:00.000000Z',
        examDate: '2020-10-15T17:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce20_sc07/Business Studies XI Part-01.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'RIE Campus, Shyamla Hills, Bhopal',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMDM=',
        title: 'Business Studies XII Part-I',
        url: '/nd2_nce19_sc03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Punnam Veeraiah',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc03/bst 03.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'RIE Campus, Shyamla Hills, Bhopal',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzOTQ=',
        title: 'C Programming and Assembly Language',
        url: '/nd1_noc20_cs94/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Janakiraman',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDY=',
        title: 'C and C++',
        url: '/nd2_aic20_sp06/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-11T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp06/CandCPP.png',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNTM=',
        title: 'C/C++ - Bengali',
        url: '/nd2_aic20_sp53/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-29T09:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp06/CandCPP.png',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNDM=',
        title: 'C/C++ - Hindi',
        url: '/nd2_aic20_sp43/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-29T09:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp06/CandCPP.png',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNDg=',
        title: 'C/C++ - Tamil',
        url: '/nd2_aic20_sp48/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-29T09:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp06/CandCPP.png',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMDM=',
        title: 'CIT-001:\u00a0Fundamentals of Computer Systems',
        url: '/nd2_nou20_cs03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Shri. Mangala Prasad Mishra ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs03/7. Fundamentals of Computer System_1.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMDQ=',
        title: 'CIT-002:\u00a0Introduction to Information Technology',
        url: '/nd2_nou20_cs04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Shri. Akshay Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs04/CIT-002.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMDU=',
        title:
          'CIT-003:\u00a0 Web Based Technologies and Multimedia Applications',
        url: '/nd2_nou20_cs05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof.P. V. Suresh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs05/CIT-003 Cover Page.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMjY=',
        title: 'Calculus Of One Real Variable',
        url: '/nd1_noc20_ma26/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Joydeep Dutta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMjc=',
        title: 'Calculus Of Several Real Variables',
        url: '/nd1_noc20_ma27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Joydeep Dutta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX2dlMDI=',
        title: 'Cancer Fundamentals',
        url: '/nd2_aic20_ge02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Mrs Jyotsna Govil',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-10T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_ge02/Screenshot 2020-03-11 at 5.26.16 PM.png',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Cancer Society',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMTY=',
        title: 'Capstone Project ',
        url: '/nd2_ntr20_ed16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Prasanta Sarkar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-14T08:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed16/559.gif',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Kolkata',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMTQ=',
        title: 'Cell Biology',
        url: '/nd2_cec20_ma14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. K. Sanatombi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-15T00:00:00.000000Z',
        endDate: '2020-11-30T00:00:00.000000Z',
        examDate: '2020-12-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_bt12/Untitled-1.jpg?seed=80320\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_bt12/Untitled-1.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Assistant Professor, Department of Biotechnology, Manipur University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNTg=',
        title:
          'CellDesigner - modeling tool for gene-regulatory and biochemical networks ',
        url: '/nd2_aic20_sp58/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp58/CellDesigner.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2FnMTI=',
        title: 'Certificate course in Environmental Sustainability ',
        url: '/nd2_nou20_ag12/preview',
        explorerSummary: '',
        explorerInstructorName:
          '1.\tDr. M. Rajesh 2. Dr. Sindhu P Nair, 3. Dr. Jalajakumari VT, 4. Dr. P Unnikrishnan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T20:00:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ag12/Certificate_Course_In_Env_Sust.jpg',
        credits: 4,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'IGNOU Regional Centre, Vatakara',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MjU=',
        title: 'Chemical Crystallography',
        url: '/nd1_noc20_cy25/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Angshuman Roy Choudhury',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISER Mohali',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMzQ=',
        title: 'Chemical Engineering Thermodynamics',
        url: '/nd1_noc20_ch34/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Jayant K. Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_28', category: null },
          { name: 'Domain_29', category: null },
          { name: 'Domain_30', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjg=',
        title: 'Chemical Process Control',
        url: '/nd1_noc20_ch28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sujit Jogwar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_9', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoNDA=',
        title: 'Chemical Process Intensification',
        url: '/nd1_noc20_ch40/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Subrata Kumar Majumdar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMzg=',
        title: 'Chemical Process Safety',
        url: '/nd1_noc20_ch38/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shishir Sinha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_29', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjU=',
        title: 'Chemical Reaction Engineering-I',
        url: '/nd1_noc20_ch25/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Bishnupada Mandal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_28', category: null },
          { name: 'Domain_29', category: null },
          { name: 'Domain_30', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTU=',
        title: 'Chemistry XI Part-I',
        url: '/nd2_nce19_sc15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. R.K. Parashar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc15/chem XI Part 1.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTY=',
        title: 'Chemistry XI Part-II',
        url: '/nd2_nce19_sc16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. R.K. Parashar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc16/chem XI part 2.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTc=',
        title: 'Chemistry XII Part-I',
        url: '/nd2_nce19_sc17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Alka Mehrotra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc17/chem XII Part 1.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMTY=',
        title:
          'Chemistry of d-Block Elements, Quantum Chemistry and Spectroscopy',
        url: '/nd2_cec20_ma16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Niraj',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-10-24T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Dr. Harisingh Gour Vishwavidyalaya, Sagar (M.P.)',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2VkMDg=',
        title: 'Children with Developmental challenges',
        url: '/nd2_cec20_ed08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Mrs.V.Kavitha Kiran ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-08-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-05T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ed08/madan-01.jpg',
        credits: 3,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute:
          'The English and Foreign Languages University (Host University)',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNzY=',
        title: 'Classical Sociological Theory',
        url: '/nd1_noc20_hs76/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. R. Santhosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjU=',
        title: 'Cloud computing',
        url: '/nd1_noc20_cs65/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Soumya Kanti Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_40', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs20.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MTk=',
        title: 'Co-Ordination Chemistry (Chemistry Of Transition Elements)',
        url: '/nd1_noc20_cy19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debashis Ray',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODA=',
        title: 'Cognition, Transformation and Lives',
        url: '/nd1_noc20_hs80/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Alok Bajpai',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMzY=',
        title: 'Colloids and Surfaces',
        url: '/nd1_noc20_ch36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Basavaraju',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMzA=',
        title: 'Communication Research ',
        url: '/nd2_cec20_ge30/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Narasimhamurthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T00:00:00.000000Z',
        endDate: '2020-10-30T00:00:00.000000Z',
        examDate: '2020-11-15T09:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ugc19_hs23/communication1.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: ' Bengaluru Central University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2VkMTc=',
        title: 'Communication Technologies in Education ',
        url: '/nd2_cec20_ed17/preview',
        explorerSummary: '',
        explorerInstructorName: ' Dr.Dhaneswar Harichandan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '2020-11-30T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ed17/COURSE PICTURE.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'University of Mumbai',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNTA=',
        title: 'Complex Analysis',
        url: '/nd1_noc20_ma50/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Pranav Haridas',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ma01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'Kerala School of Mathematics',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzg=',
        title: 'Computational Commutative Algebra',
        url: '/nd1_noc20_ma38/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Manoj Kummini',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_ma04/BBM.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'CMI',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzQ=',
        title: 'Computational Continuum Mechanics',
        url: '/nd1_noc20_me74/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sachin Singh Gautam',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_12', category: null },
          { name: 'Domain_11', category: null },
          { name: 'Domain_2', category: null },
          { name: 'Domain_1', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me21.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lODI=',
        title: 'Computational Fluid Dynamics using Finite Volume Method',
        url: '/nd1_noc20_me82/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Kameswararao Anupindi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_10', category: null },
          { name: 'Domain_12', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me06.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDI=',
        title: 'Computational Number Theory and Algebra',
        url: '/nd1_noc20_ma42/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nitin Saxena',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Mathematics', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_ma04/BBM.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3BoMjA=',
        title: 'Computational Physics',
        url: '/nd1_noc20_ph20/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Apratim Chatterji, Prof. Prasenjit Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Physics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Physics/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISER Pune',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMTU=',
        title: 'Computer Aided Design / Computer Aided Manufacturing',
        url: '/nd2_nou20_cs15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. K.Tamil Mannan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs15/CAD- CAM.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MjM=',
        title: 'Computer Aided Drug Design',
        url: '/nd1_noc20_bt23/preview',
        explorerSummary:
          'Department of Biotechnology \u0026amp; Bio engineering Engineering\u003Cspan class="yui-tag-span yui-tag" tag="span" style="background-color: rgb(0, 0, 191);"\u003E\u003Cbr\u003E\u003C/span\u003E\u003Cb\u003E\u003C/b\u003E',
        explorerInstructorName: 'Prof. Mukesh Doble',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_8', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODg=',
        title: 'Computer Aided Power System Analysis',
        url: '/nd1_noc20_ee88/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Biswarup Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_34', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2NzMTE=',
        title: 'Computer Fundamentals',
        url: '/nd2_cec20_cs11/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sanjay Tanwani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-17T18:30:00.000000Z',
        endDate: '2020-09-22T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_cs11/computer.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Devi Ahilya Viswavidyalaya, Indore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzOTA=',
        title: 'Computer Graphics',
        url: '/nd1_noc20_cs90/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Samit Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_23', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs01.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX29lMDM=',
        title: 'Computer Methods Of Structural Analysis Of Offshore Structures',
        url: '/nd1_noc20_oe03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Srinivasan Chandrasekaran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'OCEAN_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_oe01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjQ=',
        title: 'Computer architecture and organization',
        url: '/nd1_noc20_cs64/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Indranil Sengupta, Prof. Kamalika Datta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTE=',
        title: 'Concepts of Thermodynamics',
        url: '/nd1_noc20_me51/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Suman Chakraborty, Prof. Aditya Bandopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMTQ=',
        title: 'Concrete Technology',
        url: '/nd2_nou20_cs14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Munish Kumar Bhardwaj',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs14/Concrete technology Thumbnail.jpg',
        credits: 2,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2x3MDI=',
        title:
          'Constitution of India and Environmental Governance: Administrative and Adjudicatory Process',
        url: '/nd1_noc20_lw02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sairam Bhat, Prof. M. K. Ramesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Law', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_lw02/shutterstock_665185990_250x90.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'National Law School of India University',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2x3MDM=',
        title: 'Constitutional Studies',
        url: '/nd1_noc20_lw03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sudhir Krishnaswamy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Law', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_lw03/rsz_shutterstock_1198785832.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'National Law School of India University',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzI=',
        title: 'Constrained and unconstrained optimization',
        url: '/nd1_noc20_ma32/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Adrijit Goswami, Prof. Debjani Chakraborty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDI=',
        title: 'Consumer Buying Behaviour',
        url: '/nd2_imb20_mg42/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ashish Hathi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg42/Course image.PNG',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'L.N. Welingkar Institute of Management Development \u0026 Research',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTc=',
        title: 'Consumer Psychology',
        url: '/nd1_noc20_hs57/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Naveen Kashyap',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMDg=',
        title: 'Contemporary Architecture and Design',
        url: '/nd1_noc20_ar08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Saptarshi Kolay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Architecture%20and%20Planning/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDY=',
        title: 'Continuous Quality Improvement : Tools and Techniques',
        url: '/nd2_imb20_mg46/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sanjeev Singh ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-31T00:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg46/course pic.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Co-Chair of Research Committee at NABH Quality Council of India ',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjI=',
        title: 'Control engineering',
        url: '/nd1_noc20_ee62/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ramkrishna Pasumarthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_14', category: null },
          { name: 'Domain_34', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTA=',
        title: 'Control systems',
        url: '/nd1_noc20_ee90/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. C. S. Shankar Ram',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Design%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMjc=',
        title: 'Cooperatives and Producer Companies',
        url: '/nd2_imb20_mg27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Trilochan Sastry',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T05:30:00.000000Z',
        endDate: '2020-10-31T17:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg27/PP250xBI.jpg',
        credits: null,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTc=',
        title: 'Corporate Finance',
        url: '/nd2_cec20_mg17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Rashi Goplani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-10-11T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg17/WhatsApp Image 2020-05-23 at 11.04.49 PM.jpeg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'New L J Commerce College, AHMEDABAD.',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjg=',
        title: 'Corporate Law',
        url: '/nd2_cec20_mg28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. (Dr.) Harpreet Kaur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-10-31T17:30:00.000000Z',
        examDate: '2020-11-14T04:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Law', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          ' https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg28/resize Corporate Law Course Picture.png?seed=56030\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg28/resize Corporate Law Course Picture.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'National Law University Delhi',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMjE=',
        title: 'Corporate Tax Planning',
        url: '/nd2_cec20_hs21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor Anirban Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T19:00:00.000000Z',
        endDate: '2020-10-24T19:00:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Law', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Netaji Subhas Open University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2NtMDI=',
        title: 'Corporate Tax Planning',
        url: '/nd2_cec20_cm02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor Anirban Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T19:00:00.000000Z',
        endDate: '2020-10-24T19:00:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Commerce', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Netaji Subhas Open University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjc=',
        title: 'Corrosion - Part II',
        url: '/nd1_noc20_mm27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Kallol Mondal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'METALLURGY_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Metallurgy%20and%20Material%20Science/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTM=',
        title: 'Cost Accounting',
        url: '/nd1_noc20_mg53/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Varadraj Bapat',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/c.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2xiMDc=',
        title: 'Criminalistics ',
        url: '/nd2_cec20_lb07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Devasish Bose',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-06T00:00:00.000000Z',
        endDate: '2020-08-31T00:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_lb07/Criminilistic.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Criminology \u0026 Forensic Science',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X21hMDY=',
        title: 'Critical Thinking',
        url: '/nd2_aic19_ma06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Partha Chatterjee ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic19_ma06/3912_large.jpg',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'SHIV NADAR UNIVERSITY',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X2FzMDQ=',
        title: 'Cultural Studies',
        url: '/nd2_aic19_as04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Supriya Chaudhuri',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Arts', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic19_as04/4258_large.jpg',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Jadavpur University',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzU=',
        title: 'Customer Relationship Management',
        url: '/nd2_imb20_mg35/preview',
        explorerSummary: '',
        explorerInstructorName: 'Shainesh G',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-30T18:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg35/iimbx_mk210x_PIC.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTc=',
        title: 'Customer Relationship Management',
        url: '/nd1_noc20_mg57/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Swagato Chatterjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_25', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2NzMTU=',
        title: 'Cyber Security',
        url: '/nd2_cec20_cs15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr.G.PADMAVATHI',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T19:00:00.000000Z',
        endDate: '2020-10-11T18:00:00.000000Z',
        examDate: '2020-11-15T09:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_cs15/Course-pic.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Avinashilingam Institute for Home Science \u0026  Higher Education for Women,Coimbatore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vczE5X2VkMDE=',
        title: 'D.EL.ED. COURSE 501-510',
        url: '/nd2_nos19_ed01/preview',
        explorerSummary: '',
        explorerInstructorName: 'Mr. Chanchal Kumar Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-31T18:30:00.000000Z',
        endDate: '2020-09-30T00:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nos19_ed01/dfdfd.JPG',
        credits: 10,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'National Institute of Open Schooling (NIOS)',
        ncCode: 'NIOS',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODQ=',
        title: 'DC Microgrid and Control System',
        url: '/nd1_noc20_ee84/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Avik Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2VkMjA=',
        title: 'DEVELOPING LIFE SKILLS',
        url: '/nd2_cec20_ed20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. (Dr.) M.N. Mohamedunni Alias Musthafa',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-21T18:30:00.000000Z',
        endDate: '2020-09-23T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-06-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ed20/pic.jpeg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Central University of Kerala',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDg=',
        title: 'DWSIM',
        url: '/nd2_aic20_sp08/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp08/DWSIM.png',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FnMDI=',
        title: 'Dairy and Food process and products technology',
        url: '/nd1_noc20_ag02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Tridib Kumar Goswami',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Agricultural%20and%20Food%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjA=',
        title: 'Data Base Management System',
        url: '/nd1_noc20_cs60/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Partha Pratim Das, Prof. Samiran Chattopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs09.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2NzMTI=',
        title: 'Data Mining',
        url: '/nd2_cec20_cs12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Mr. L. Abraham David',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-09T19:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-15T04:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_cs12/COURSE PICTURE.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'St.John\u2019s College, Palayamkottai',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNzI=',
        title: 'Data Science for Engineers',
        url: '/nd1_noc20_cs72/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Ragunathan Rengasamy, Prof. Shankar Narasimhan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_15', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs28.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODU=',
        title: 'Data Structure and algorithms using Java',
        url: '/nd1_noc20_cs85/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debasis Samanta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xiMDY=',
        title: 'Database and Content Organisation',
        url: '/nd2_nou20_lb06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. V. V. Subrahmanyam',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T19:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lb06/DBase-and-Content-Org_Course_Image.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTk=',
        title: 'Decision Support System for Managers',
        url: '/nd1_noc20_mg59/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Kunal Kanti Ghosh, Prof. Anupam Ghosh, Prof Sujoy Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur, IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjM=',
        title: 'Decision-Making Under Uncertainty',
        url: '/nd1_noc20_mg63/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. N. Gautam',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Commerce', category: null },
          { name: 'Domain_31', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'Texas A\u0026M Univ.',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjI=',
        title: 'Deep Learning',
        url: '/nd1_noc20_cs62/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Prabir Kumar Biswas',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzQ=',
        title: 'Deep Learning For Visual Computing',
        url: '/nd1_noc20_ee74/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debdoot Sheet',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODg=',
        title: 'Deep Learning for Computer Vision',
        url: '/nd1_noc20_cs88/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Vineeth N Balasubramanian',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Hyderabad',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjg=',
        title: 'Defects in Crystalline Solids (Part-I)',
        url: '/nd1_noc20_mm28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shashank Shekhar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'METALLURGY_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Metallurgy%20and%20Material%20Science/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMjc=',
        title: 'Delhi Sultanate (1206-1550)',
        url: '/nd2_cec20_hs27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Tinni Goswami',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T18:30:00.000000Z',
        endDate: '2020-07-20T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-06-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'St. Xavier\u2019s College (Autonomous), Kolkata, ',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODY=',
        title: 'Demystifying Networking',
        url: '/nd1_noc20_cs86/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sridhar Iyer',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlMzk=',
        title: 'Design Of Reinforced Concrete Structures',
        url: '/nd1_noc20_ce39/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nirjhar Dhang',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_39', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nMzg=',
        title: 'Design Thinking - A Primer',
        url: '/nd1_noc20_mg38/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ashwin Mahalingam, Prof. Bala Ramadurai',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg09.jpg',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2VkMDI=',
        title: 'Design and Facilitation of E-Learning Courses',
        url: '/nd2_nou20_ed02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. G. Mythili',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T19:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ed02/Design_and_Facilitation_of_e-learning_Courses_Image.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNzE=',
        title: 'Design and analysis of algorithms',
        url: '/nd1_noc20_cs71/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Madhavan Mukund',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_23', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs27.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'Chennai Mathematical Institute',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTU=',
        title: 'Design of Masonry Structures',
        url: '/nd1_noc20_ce55/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Arun Menon',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_39', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNTc=',
        title: 'Design of photovoltaic systems',
        url: '/nd1_noc20_ee57/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. L Umanand',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlMzc=',
        title: 'Design of steel structures',
        url: '/nd1_noc20_ce37/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Damodar Maity',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_39', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2RlMTM=',
        title: 'Design, Technology and Innovation',
        url: '/nd1_noc20_de13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. B.K. Chakravarthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'DESIGN_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_de03/DTI%20banner.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X2RlMDE=',
        title: 'Designing Digital Solution',
        url: '/nd2_aic19_de01/preview',
        explorerSummary: '',
        explorerInstructorName: 'Mohit Gambhir',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'DESIGN_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic19_de01/newcourse.jpg',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: '',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2dlMTk=',
        title: 'Designing learner-centric e-learning in STEM disciplines',
        url: '/nd1_noc20_ge19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sahana Murthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Multidisciplinary', category: null },
          { name: 'Domain_21', category: null },
          { name: 'Domain_20', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc19_ge27/E-learning%20Course%20image_250x90%20copy.PNG?seed=32201\u0026url=https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc19_ge27/E-learning%20Course%20image_250x90%20copy.PNG',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNDM=',
        title: 'Developing Soft Skills and Personality',
        url: '/nd1_noc20_hs43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. T. Ravichandran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNzg=',
        title: 'Development Research Methods',
        url: '/nd1_noc20_hs78/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajshree Bedamatta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Domain_20', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X2dlMDE=',
        title:
          'Development of Assistive technology for persons with Disabilities',
        url: '/nd2_aic19_ge01/preview',
        explorerSummary: '',
        explorerInstructorName: 'Indumathi Rao',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/arp19_ap07/4258_large.jpg',
        credits: null,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'C B R Network',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMjI=',
        title: 'Differential Calculus',
        url: '/nd2_cec20_ma22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Bijumon Ramalayathil',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T18:30:00.000000Z',
        endDate: '2020-08-27T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ma22/pic.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Mahatma Gandhi College, Iritty, Keezhur PO, Kannur Dt \u2013 670 703, Kerala',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzA=',
        title: 'Digital Circuits',
        url: '/nd1_noc20_ee70/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Santanu Chattopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_41', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2xiMDY=',
        title: 'Digital Forensic',
        url: '/nd2_cec20_lb06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Navjot Kaur Kanwal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-10-17T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_lb06/cp.png',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Dr. Harisingh Gour Vishwavidyalaya, Sagar (M.P.)',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzU=',
        title: 'Digital Image Processing',
        url: '/nd1_noc20_ee75/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Prabir Kumar Biswas',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_7', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2xiMDg=',
        title: 'Digital Library',
        url: '/nd2_cec20_lb08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Jagdish Arora ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-10-26T17:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_lb03/Digital Library.PNG',
        credits: 5,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Former Director, Information and Library Network (INFLIBNET) Centre, Gandhinagar',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjk=',
        title: 'Digital Marketing',
        url: '/nd2_cec20_mg29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Tejinderpal Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T19:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg29/john-schnobrich-FlPc9_VocJ4-unsplash.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Panjab University, Chandigarh',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjU=',
        title: 'Digital Photography',
        url: '/nd2_cec20_ge25/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Narayan Patidar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-17T18:30:00.000000Z',
        endDate: '2020-09-21T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge25/photography_CourseImage.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Devi Ahilya Viswavidyalaya, Indore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzY=',
        title: 'Digital VLSI Testing',
        url: '/nd1_noc20_ee76/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Santanu Chattopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2NtMDM=',
        title: 'Direct Tax - Laws and Practice',
        url: '/nd2_cec20_cm03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. (Dr.) Subhrangshu Sekhar Sarkar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T00:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T06:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Commerce', category: null },
          { name: 'Management', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ugc19_hs27/rsz_direct_tax.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Tezpur University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMTM=',
        title: 'Disaster Recovery And Build Back Better',
        url: '/nd1_noc20_ar13/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Ram Sateesh Pasupuleti, Prof. Subhojyothi Samaddar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Architecture%20and%20Planning/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODI=',
        title: 'Discrete Mathematics',
        url: '/nd1_noc20_cs82/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sudarshan Iyengar, Prof. Neeldhara',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_23', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs37.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Ropar, IIT Gandhinagar',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMTE=',
        title: 'Diseases of horticultural crops and their management',
        url: '/nd2_cec20_ag11/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Bireshwar Sinha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T18:30:00.000000Z',
        endDate: '2020-11-29T18:30:00.000000Z',
        examDate: '2020-12-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag11/Untitled-1.jpg',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'College of Agriculture, Central Agricultural University, Imphal',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xiMDg=',
        title: 'Document Processing and Organisation',
        url: '/nd2_nou20_lb08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Jaideep Sharma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lb08/Prof.JaideepCourseImage.jpg',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MjQ=',
        title: 'Drug Delivery: Principles and Engineering',
        url: '/nd1_noc20_bt24/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rachit Agarwal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_4', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDc=',
        title: 'Drupal - Content Management System',
        url: '/nd2_aic20_sp07/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Multidisciplinary', category: null },
          { name: 'Management', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp07/Drupal.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lODk=',
        title: 'Dynamic Behaviour Of Materials',
        url: '/nd1_noc20_me89/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Prasenjit Khanikar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_2', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDY=',
        title: 'Dynamical System and Control',
        url: '/nd1_noc20_ma46/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. N. Sukavanam, Prof. D. N. Pandey',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX29lMDI=',
        title: 'Dynamics of Ocean Structures',
        url: '/nd1_noc20_oe02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Srinivasan Chandrasekaran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'OCEAN_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_oe01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2VkMTk=',
        title: 'E-assessment',
        url: '/nd2_cec20_ed19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr.C.Karthik Deepa',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T19:00:00.000000Z',
        endDate: '2020-10-11T18:00:00.000000Z',
        examDate: '2020-11-15T04:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ed19/course image F.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Avinashilingam Institute for Home Science \u0026  Higher Education for Women,Coimbatore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTk=',
        title: 'ENTREPRENEURSHIP DEVELOPMENT',
        url: '/nd2_cec20_mg19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Nilam Panchal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T18:30:00.000000Z',
        endDate: '2020-10-04T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg19/WhatsApp Image 2020-05-21 at 9.18.09 PM.jpeg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'B.K. School of Business Management, Gujarat University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNTk=',
        title:
          'ESim - EDA tool for circuit design, simulation, analysis and PCB design',
        url: '/nd2_aic20_sp59/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp59/eSim.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2VkMTg=',
        title: 'Early Childhood Care and Education (ECCE)',
        url: '/nd2_cec20_ed18/preview',
        explorerSummary: '',
        explorerInstructorName: 'K.Arockia Maraichelvi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T18:30:00.000000Z',
        endDate: '2020-10-11T17:30:00.000000Z',
        examDate: '2020-11-15T08:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ed18/COURSE PICTURE.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Avinashilingam Institute for Home Science \u0026  Higher Education for Women,Coimbatore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlMzM=',
        title: 'Earth Sciences For Civil Engineering Part - I \u0026 II',
        url: '/nd1_noc20_ce33/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Javed N. Malik',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjg=',
        title: 'Earth System Science',
        url: '/nd2_cec20_ge28/preview',
        explorerSummary: '',
        explorerInstructorName: 'M. S. Sisodia',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T18:30:00.000000Z',
        endDate: '2020-10-16T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'J.N.V. University, Jodhpur Rajasthan',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTI=',
        title: 'Earthquake Resistant Design of Foundations',
        url: '/nd1_noc20_ce52/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. B. K. Maheshwari',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ce02.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2dlMTY=',
        title: 'Ecology and Environment',
        url: '/nd1_noc20_ge16/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Abhijit P Deshpande, Prof. Ravi Krishna R',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Multidisciplinary', category: null },
          { name: 'Domain_17', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Multidisciplinary/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNzc=',
        title: 'Ecology and Society',
        url: '/nd1_noc20_hs77/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Ngamjahao Kipgen',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjU=',
        title: 'Ecommerce Technologies',
        url: '/nd2_cec20_mg25/preview',
        explorerSummary: '',
        explorerInstructorName: 'G.Selva Jeba',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-09T19:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-15T14:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg25/Course-Image-Final.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Grace Technology Solutions',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzQ=',
        title: 'Economic History of India from 1857 to 1947',
        url: '/nd2_cec20_hs34/preview',
        explorerSummary: '',
        explorerInstructorName: 'LINDA GEORGE',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-28T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-05T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-25T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs34/Economic-History-of-India.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'ST. ALBERT\u2019S COLLEGE (AUTONOMOUS) COLLEGE, ERNAKULAM - 682018',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTg=',
        title: 'Economic XI Part-I',
        url: '/nd2_nce19_sc18/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Neeraja Rashmi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc18/econimics01may2020.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTk=',
        title: 'Economic XII Part-I',
        url: '/nd2_nce19_sc19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Jaya Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc19/eco XII i.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjk=',
        title: 'Economics of Health and Health Care',
        url: '/nd1_noc20_mg69/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Angan Sengupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2VkMTA=',
        title: 'Educational Technology',
        url: '/nd2_cec20_ed10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Naziya Hasan ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-15T00:00:00.000000Z',
        endDate: '2020-11-30T00:00:00.000000Z',
        examDate: '2020-12-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ed10/ET.jpg',
        credits: 3,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute:
          'Assistant Professor, Department of Teacher Education, Manipur University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNDc=',
        title: 'Educational leadership',
        url: '/nd1_noc20_hs47/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Atasi Mohanty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Domain_20', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODY=',
        title: 'Electrical Distribution System Analysis',
        url: '/nd1_noc20_ee86/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. G. B. Kumbhar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODE=',
        title: 'Electrical Equipment and Machines: Finite Element Analysis',
        url: '/nd1_noc20_ee81/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shrikrishna V. Kulkarni',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjA=',
        title: 'Electrical Machines - I',
        url: '/nd1_noc20_ee60/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Tapas Kumar Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_34', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMDg=',
        title: 'Electricity \u0026 Safety Measures',
        url: '/nd2_nou20_cs08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Rakhi Sharma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs08/electric-1080584_1920.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMTU=',
        title: 'Elementary Stereology for Quantitative Metallography',
        url: '/nd1_noc20_mm15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sandeep Sangal, Prof. Sankaran.S',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'METALLURGY_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Metallurgy%20and%20Material%20Science/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur, IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODE=',
        title: 'Elements of Visual Representation',
        url: '/nd1_noc20_hs81/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shatarupa Thakurta Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MjE=',
        title: 'Endocrinology',
        url: '/nd2_cec20_bt21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Manzoor Ahmad Mir',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-09T18:30:00.000000Z',
        endDate: '2020-10-24T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt21/Endocrinology Course Image Final F .jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'School of Biological Sciences, University of Kashmir',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNjg=',
        title: 'Energy Economics And Policy',
        url: '/nd1_noc20_hs68/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shyamasree Dasgupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Domain_18', category: null },
          { name: 'Domain_17', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Mandi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMDk=',
        title: 'Energy Resources and conversion processes',
        url: '/nd2_nou20_cs09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Shweta Tripathi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs09/renewable_energy_sources_and _their_application.jpg',
        credits: 4,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjA=',
        title: 'Energy conservation and waste heat recovery',
        url: '/nd1_noc20_mm20/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Prasanta Kumar Das, Prof. A Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'METALLURGY_COURSES', category: null },
          { name: 'Domain_18', category: null },
          { name: 'Domain_17', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNDc=',
        title: 'Engineering Fracture Mechanics',
        url: '/nd1_noc20_me47/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. K. Ramesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzc=',
        title: 'Engineering Mathematics - I',
        url: '/nd1_noc20_ma37/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Jitendra Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNDY=',
        title: 'Engineering Mechanics',
        url: '/nd1_noc20_me46/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. K. Ramesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_11', category: null },
          { name: 'Domain_10', category: null },
          { name: 'Domain_2', category: null },
          { name: 'Domain_1', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lOTQ=',
        title: 'Engineering Metrology',
        url: '/nd1_noc20_me94/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. Ramkumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMDk=',
        title: 'Engineering Thermodynamics',
        url: '/nd1_noc20_ae09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D.P. Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AERO_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Aerospace%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzk=',
        title: 'Engineering drawing and computer graphics',
        url: '/nd1_noc20_me79/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajaram Lakkaraju',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_35', category: null },
          { name: 'Domain_24', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me07.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNjY=',
        title: 'Entrepreneurship and IP strategy',
        url: '/nd1_noc20_hs66/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Gouri Gargate',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Law', category: null },
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Management', category: null },
          { name: 'Domain_20', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs01.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDc=',
        title: 'Entrepreneurship: Do your Venture',
        url: '/nd2_imb20_mg47/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof Suresh Bhagavatula',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-31T00:00:00.000000Z',
        endDate: '2020-10-02T00:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg47/courseimage.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X2dlMDU=',
        title: 'Environment Natural resources and Sustainable Development',
        url: '/nd2_aic19_ge05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prabhakar Rao Jandhyala ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic19_ge05/newcourse.jpg',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'University of Hyderabad',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTc=',
        title: 'Environmental Chemistry',
        url: '/nd1_noc20_ce57/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Bhanu Prakash Vellanki',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_19', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzNDQ=',
        title: 'Environmental Sociology',
        url: '/nd2_cec20_hs44/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Satyapriya Rout',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T00:00:00.000000Z',
        endDate: '2020-10-31T00:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs44/image.jpeg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'University of Hyderabad',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMDU=',
        title: 'Environmental Soil Chemistry',
        url: '/nd1_noc20_ar05/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Somsubhra Chakraborty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ar01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjQ=',
        title: 'Environmental Studies',
        url: '/nd2_cec20_ge24/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Monica Jain',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-17T18:30:00.000000Z',
        endDate: '2020-09-21T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge24/evs.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Devi Ahilya Viswavidyalaya, Indore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MjA=',
        title: 'Enzymology',
        url: '/nd2_cec20_bt20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Bashir Ahmad Ganai',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-09T18:30:00.000000Z',
        endDate: '2020-10-17T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt20/enzymology.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'University of Kashmir, Srinagar',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2RlMTI=',
        title: 'Ergonomics Workplace Analysis',
        url: '/nd1_noc20_de12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Urmi R. Salve',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'DESIGN_COURSES', category: null },
          { name: 'Domain_35', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Design%20Engineering/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzU=',
        title: 'Essential Mathematics for Machine Learning',
        url: '/nd1_noc20_ma35/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sanjeev Kumar, Prof. S. K. Gupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_ma04/BBM.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDQ=',
        title: 'Ethics in Engineering Practice',
        url: '/nd1_noc20_mg44/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Susmita Mukhopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_20', category: null },
          { name: 'Domain_21', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ge02.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNjQ=',
        title: 'ExpEYES Junior - Physics and Electronics experiments',
        url: '/nd2_aic20_sp64/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp64/ExpEYES_Junior.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MzE=',
        title: 'Experimental Biotechnology',
        url: '/nd1_noc20_bt31/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Vishal Trivedi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_5', category: null },
          { name: 'Domain_6', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me04.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3BoMTY=',
        title: 'Experimental Physics I',
        url: '/nd1_noc20_ph16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Amal Kumar Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Physics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Physics/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNTY=',
        title:
          'Fabrication Techniques for MEMs-based sensors : clinical perspective',
        url: '/nd1_noc20_ee56/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Hardik Jeetendra Pandya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FnMDY=',
        title: 'Farm Machinery',
        url: '/nd1_noc20_ag06/preview',
        explorerSummary:
          'Department of Agricultural \u0026amp; Food Engineering',
        explorerInstructorName: 'Prof. V. K. Tewari',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Agricultural%20and%20Food%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTg=',
        title: 'Feminist Writings',
        url: '/nd1_noc20_hs58/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Avishek Parui',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzk=',
        title: 'Fiber Optic Communication Technology',
        url: '/nd1_noc20_ee79/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Deepa Venkitesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_33', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ee51.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNjM=',
        title: 'Film Appreciation',
        url: '/nd1_noc20_hs63/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Aysha Iqbal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTY=',
        title: 'Financial Accounting',
        url: '/nd2_cec20_mg16/preview',
        explorerSummary: '',
        explorerInstructorName: 'C.S. Dr. Manish Sitlani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-17T18:30:00.000000Z',
        endDate: '2020-09-21T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg16/financialaccounting.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Devi Ahilya Viswavidyalaya, Indore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTI=',
        title: 'Financial Accounting - IITB',
        url: '/nd1_noc20_mg52/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Varadraj Bapat',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_27', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzI=',
        title: 'Financial Accounting and Analysis',
        url: '/nd2_imb20_mg32/preview',
        explorerSummary: '',
        explorerInstructorName: 'Padmini Srinivasan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg32/Banner Image - FAA.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNzE=',
        title: 'Financial accounting - IITMandi',
        url: '/nd1_noc20_mg71/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Puran Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_27', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Mandi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjA=',
        title:
          'Finite Element Method: Variational Methods to Computer Programming',
        url: '/nd1_noc20_me60/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Atanu Banerjee , Prof. Arup Nandy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_11', category: null },
          { name: 'Domain_10', category: null },
          { name: 'Domain_2', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me07.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTU=',
        title: 'Fluid Machines',
        url: '/nd1_noc20_me55/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Suman Chakraborty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTk=',
        title: 'Fluid Mechanics',
        url: '/nd1_noc20_ce59/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Subashisa Dutta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_37', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMzM=',
        title: 'Fluid and Particle Mechanics',
        url: '/nd1_noc20_ch33/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Basavaraju, Prof. Sumesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_30', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzU=',
        title: 'Fluid dynamics and turbomachines',
        url: '/nd1_noc20_me75/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Dhiman Chatterjee, Prof. Shamit Bakshi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_18', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjY=',
        title: 'Fluidization Engineering',
        url: '/nd1_noc20_ch26/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Subrata Kumar Majumdar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMTA=',
        title: 'Food Chemistry ',
        url: '/nd2_cec20_ag10/preview',
        explorerSummary: '',
        explorerInstructorName: ' Dr.Chandra Nayaka, S.',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag10/food chemistry.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          ' Department of Studies in Biotechnology University of Mysore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMDk=',
        title: 'Food Microbiology',
        url: '/nd2_cec20_ag09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Niranjan Raj S',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-09-06T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag09/Food Microbiology.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Studies Microbiology  Karnataka State Open University Mukthagangotri',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMTM=',
        title: 'Food Microbiology and Food Safety',
        url: '/nd2_cec20_ag13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Tejpal Dhewa',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-11-30T17:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag13/Course Picture.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Central University of Haryana',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTIwX3NjMDE=',
        title: 'Food Nutrition for Healthy Living',
        url: '/nd2_nce20_sc01/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Poonam Agrawal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T20:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce20_sc01/FNHL.jpg',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DGS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMDc=',
        title: 'Food Preservation Technology',
        url: '/nd2_cec20_ag07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. GIRISH K',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag07/Food-presevation-tech.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Maharani\u2019s Science College for Women, Mysuru',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMDY=',
        title: 'Food Safety and Quality Control',
        url: '/nd2_cec20_ag06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. V.Vijaya Lakshmi ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-30T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag06/FOOD-01.jpg',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'The English and Foreign Languages University ( Host University )',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMDg=',
        title: 'Food and Nutrition',
        url: '/nd2_cec20_ag08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Asna Urooj',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag08/Food-and-Nutrition.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Studies in Food Science and Nutrition, University of Mysore.',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2FnMDk=',
        title: 'Food laws and standards',
        url: '/nd2_nou20_ag09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor M. K. Salooja',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-30T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ag02/food laws and standard_960_600_002.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FzMDM=',
        title: 'Foundation Course in Kathak',
        url: '/nd2_cec20_as03/preview',
        explorerSummary: '',
        explorerInstructorName: 'Amita Dutt',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T18:30:00.000000Z',
        endDate: '2020-07-11T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-06-24T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Arts', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_as03/Kathak_foundation2.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Rabindra Bharati University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlMzY=',
        title: 'Foundation Engineering',
        url: '/nd1_noc20_ce36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Kousik Deb',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjQ=',
        title: 'Foundation of Computational Fluid Dynamics',
        url: '/nd1_noc20_me64/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Vengadesan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_12', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lOTI=',
        title: 'Foundations of Cognitive Robotics',
        url: '/nd1_noc20_me92/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Bishakh Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me06.jpg',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNjA=',
        title: 'FrontAccouting - business accounting system',
        url: '/nd2_aic20_sp60/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Commerce', category: null },
          { name: 'Management', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp60/FrontAccounting.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FnMTQ=',
        title: 'Functional Foods and Nutraceuticals ',
        url: '/nd2_cec20_ag14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Rekha Sharma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T18:00:00.000000Z',
        endDate: '2020-11-30T18:00:00.000000Z',
        examDate: '2020-11-14T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          ' https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag14/Food.jpg?seed=74474\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ag14/Food.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Rashtrasant Tukadoji Maharaj Nagpur University, Nagpur',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0NDA=',
        title: 'Functional Genomics',
        url: '/nd1_noc20_bt40/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. S. Ganesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-10-08T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_8', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2RlMTA=',
        title: 'Functional and Conceptual Design',
        url: '/nd1_noc20_de10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Asokan T',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'DESIGN_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Design%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjQ=',
        title: 'Fundamental of Insurance',
        url: '/nd2_cec20_mg24/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr.K.UMA',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-09T18:30:00.000000Z',
        endDate: '2020-08-30T17:30:00.000000Z',
        examDate: '2020-11-15T08:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg24/COURSE PICTURE.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Madurai Kamaraj University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lODg=',
        title: 'Fundamentals Of Artificial Intelligence',
        url: '/nd1_noc20_me88/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shyamanta M. Hazarika',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Multidisciplinary', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjk=',
        title: 'Fundamentals Of Material Processing - I',
        url: '/nd1_noc20_mm29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shashank Shekhar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'METALLURGY_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Metallurgy%20and%20Material%20Science/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTk=',
        title: 'Fundamentals of Compressible Flow',
        url: '/nd1_noc20_me59/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Niranjan Sahoo',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_12', category: null },
          { name: 'Domain_10', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me07.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lODU=',
        title: 'Fundamentals of Conduction and Radiation',
        url: '/nd1_noc20_me85/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Amaresh Dalal, Prof. Dipankar N.Basu',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_18', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lODE=',
        title: 'Fundamentals of Convective Heat Transfer',
        url: '/nd1_noc20_me81/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Amaresh Dalal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_10', category: null },
          { name: 'Domain_12', category: null },
          { name: 'Domain_18', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me07.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTk=',
        title: 'Fundamentals of Electric vehicles: Technology \u0026 Economics',
        url: '/nd1_noc20_ee99/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Ashok Jhunjhunwala, Prof. Kaushal Jha, Prof. L Kannan, Prof. Prabhjot Kaur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ee18.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjg=',
        title: 'Fundamentals of Electrical Engineering',
        url: '/nd1_noc20_ee68/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debapriya Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjM=',
        title: 'Fundamentals of Financial Accounting',
        url: '/nd2_cec20_mg23/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sweta S. Metha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T06:30:00.000000Z',
        endDate: '2020-09-13T17:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg23/Financial Accounting_new title_.bmp?seed=55659\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg23/Financial Accounting_new title_.bmp',
        credits: 4,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Savitribai Phule Pune University, Pune',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FnMDE=',
        title: 'Fundamentals of Food Process Engineering',
        url: '/nd1_noc20_ag01/preview',
        explorerSummary:
          '\u003Cspan class="yui-tag-span yui-tag" tag="span" style="background-color: rgb(0, 0, 191);"\u003E\u003Cbr\u003E\u003C/span\u003E\u003Cb\u003E\u003C/b\u003E\n',
        explorerInstructorName: 'Prof. Jayeeta Mitra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Agricultural%20and%20Food%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjI=',
        title: 'Fundamentals of Office Management \u0026 Methods',
        url: '/nd2_cec20_mg22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Rupali Sheth',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T07:00:00.000000Z',
        endDate: '2020-09-27T18:00:00.000000Z',
        examDate: '2020-11-15T04:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg22/Fundamentals of Office Management_thumb.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Savitribai Phule Pune University, Pune',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjc=',
        title:
          'Fundamentals of Outcome-Based Curriculum in Engineering Education',
        url: '/nd2_ntr20_ed27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Joshua Earnest',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-28T17:30:00.000000Z',
        examDate: '2020-11-14T08:30:00.000000Z',
        enrollmentEndDate: '2020-08-17T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed27/Fundamet.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Bhopal  ',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjc=',
        title: 'Fundamentals of Rural sociology and Educational Psychology',
        url: '/nd2_cec20_ge27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Homen Thangjam',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-04T18:30:00.000000Z',
        endDate: '2020-11-29T18:30:00.000000Z',
        examDate: '2020-12-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge27/AGRI EXT.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Dept. of Political Science \u0026 Human Rights, Indira Gandhi National Tribal University \u2013 Regional Campus Manipur',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjg=',
        title:
          'Fundamentals of Surface Engineering: Mechanisms,Processes and Characterizations',
        url: '/nd1_noc20_me68/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D K Dwivedi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjU=',
        title: 'Fundamentals of electronic device fabrication',
        url: '/nd1_noc20_mm25/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Parasuraman Swaminathan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'METALLURGY_COURSES', category: null },
          { name: 'Domain_16', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Metallurgy%20and%20Material%20Science/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjc=',
        title: 'Fundamentals of manufacturing processes',
        url: '/nd1_noc20_me67/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D K Dwivedi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0Mzc=',
        title: 'Fundamentals of micro and nanofabrication',
        url: '/nd1_noc20_bt37/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Shankar Selvaraja, Prof. Sushobhan avasthi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNjI=',
        title: 'GChemPaint - 2D chemical structure editor',
        url: '/nd2_aic20_sp62/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp62/GChemPaint.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzI=',
        title: 'GEOGRAPHY OF INDIA',
        url: '/nd2_cec20_hs32/preview',
        explorerSummary: '',
        explorerInstructorName: 'PROF. A.  BALASUBRAMANIAN',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs32/GOI.jpeg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'DoS in Geology University of Mysore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzA=',
        title: 'GEOGRAPHY OF TOURISM',
        url: '/nd2_cec20_hs30/preview',
        explorerSummary: '',
        explorerInstructorName: 'PROF. A.  BALASUBRAMANIAN',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs30/GOT.jpeg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'DoS in Geology University of Mysore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTE=',
        title: 'GPS Surveying',
        url: '/nd1_noc20_ce51/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. K. Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDk=',
        title: 'Gedit Text Editor',
        url: '/nd2_aic20_sp09/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp09/gedit-Text-Editor.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTk=',
        title: 'Gender and literature',
        url: '/nd1_noc20_hs59/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Avishek Parui',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDI=',
        title: 'Gender justice and workplace security',
        url: '/nd1_noc20_mg42/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Dipa Dube',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MzI=',
        title: 'Genetic Engineering: Theory And Application',
        url: '/nd1_noc20_bt32/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Vishal Trivedi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_5', category: null },
          { name: 'Domain_6', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNjE=',
        title: 'GeoGebra 5.04',
        url: '/nd2_aic20_sp61/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp61/GeoGebra 5.04.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMjA=',
        title: 'Geography XI Part-I',
        url: '/nd2_nce19_sc20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Aprana Pandey',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc20/geography01may2020.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTIwX3NjMDk=',
        title: 'Geography XI Part-II',
        url: '/nd2_nce20_sc09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Tannu Malik',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T19:30:00.000000Z',
        endDate: '2020-10-29T17:30:00.000000Z',
        examDate: '2020-10-15T17:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce20_sc09/Geography XI Part-02.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMjE=',
        title: 'Geography XII Part-I',
        url: '/nd2_nce19_sc21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Tannu Malik',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc21/geography03may2020.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESS, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDk=',
        title: 'Geosynthetics Testing Laboratory',
        url: '/nd1_noc20_ce49/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. N. Mandal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/c.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDg=',
        title: 'Geotechnical Engineering Laboratory',
        url: '/nd1_noc20_ce48/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. N. Mandal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODc=',
        title: 'German - I',
        url: '/nd1_noc20_hs87/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Milind Brahme',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs41.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODg=',
        title: 'German - II',
        url: '/nd1_noc20_hs88/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Milind Brahme',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs40.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTA=',
        title: 'Git',
        url: '/nd2_aic20_sp10/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-13T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp10/git (1).png',
        credits: 1,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDY=',
        title: 'Glass Processing Technology',
        url: '/nd1_noc20_ce46/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. K N Satyanarayana, Prof. E. Rajasekar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras, IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDc=',
        title: 'Glass in buildings : Design and applications',
        url: '/nd1_noc20_ce47/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. K N Satyanarayana, Prof. E. Rajasekar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras, IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNjI=',
        title: 'Global Navigation Satellite Systems And Applications',
        url: '/nd1_noc20_ce62/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Arun K. Saraf',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzOTY=',
        title: 'Google Cloud Computing Foundations',
        url: '/nd1_noc20_cs96/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Soumya Kanti Ghosh, Multifaculty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs20.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur, Google Cloud',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjQ=',
        title: 'Graphics and Animation Development',
        url: '/nd2_ntr20_ed24/preview',
        explorerSummary: '',
        explorerInstructorName: 'Er. Shano Solanki ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed24/giphy-downsized.gif',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Chandigarh.',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNDU=',
        title: 'Great Experiments in Psychology',
        url: '/nd1_noc20_hs45/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajlakshmi Guha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMjg=',
        title: 'Groups: Motion, symmetry and puzzles',
        url: '/nd1_noc20_ma28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Amit Kulshrestha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IISER Mohali',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjE=',
        title: 'Guidance and Counselling',
        url: '/nd2_ntr20_ed21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. R. Rajendran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-25T17:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed21/GC.JPG',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Chennai',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMjA=',
        title: 'HRM FOR NON-HR MANAGERS',
        url: '/nd2_cec20_mg20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Margie Parikh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-26T18:30:00.000000Z',
        endDate: '2020-10-18T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg20/WhatsApp Image 2020-05-23 at 10.03.08 PM.jpeg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'BK School of Professional and Management Studies,Gujarat University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTE=',
        title: 'HTML',
        url: '/nd2_aic20_sp11/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-27T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp11/HTML (1).png',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjM=',
        title: 'Hardware modeling using verilog',
        url: '/nd1_noc20_cs63/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Indranil Sengupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_41', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTA=',
        title: 'Health Research Fundamentals',
        url: '/nd1_noc20_hs50/preview',
        explorerSummary: '',
        explorerInstructorName: 'Multi Faculty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Multidisciplinary', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs20.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'National Institute of Epidemiology',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTI=',
        title: 'Heat Exchangers: Fundamentals and Design Analysis',
        url: '/nd1_noc20_me52/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Prasanta Kumar Das, Prof. Indranil Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjE=',
        title: 'Heat Transfer',
        url: '/nd1_noc20_ch21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sunando DasGupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_18', category: null },
          { name: 'Domain_28', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjE=',
        title: 'High Performance Computing for Scientists and Engineers',
        url: '/nd1_noc20_me61/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Somnath Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_10', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me03.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTI=',
        title: 'History of English Language and Literature',
        url: '/nd1_noc20_hs52/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Merin Simi Raj',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMjk=',
        title: 'History of Modern East Asia -1 (c.1840-1949)',
        url: '/nd2_cec20_hs29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Siddhartha Guha Ray',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T18:30:00.000000Z',
        endDate: '2020-07-23T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-07-23T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs29/logo MOOC Modern East Asia I.jpg',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Vivekananda College, Kolkata',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjA=',
        title: 'Hospitality Industry in Tourism',
        url: '/nd2_cec20_ge20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. H.  Rajashekar ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge20/HIIT.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Professor of Commerce  \u0026 Tourism University of Mysore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMTQ=',
        title: 'Housing Policy \u0026 Planning',
        url: '/nd1_noc20_ar14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Uttam Kumar Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Architecture%20and%20Planning/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MTc=',
        title: 'Human Genetics',
        url: '/nd2_cec20_bt17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. N. B. Ramachandra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T19:30:00.000000Z',
        endDate: '2020-09-27T17:30:00.000000Z',
        examDate: '2020-11-14T04:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt17/Human Genetics course image.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Studies in Genetics and Genomics,  University of Mysore',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMjY=',
        title: 'Human Rights and Humanitarian Law',
        url: '/nd2_cec20_ge26/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. N. Pramod Singh    ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-05T18:30:00.000000Z',
        endDate: '2020-11-29T18:30:00.000000Z',
        examDate: '2020-12-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge26/FITNESS.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'L.M.S Law College, Imphal Manipur',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNDg=',
        title: 'Human resource development',
        url: '/nd1_noc20_hs48/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. KBL Srivastava',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Humanities_and_Social_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjI=',
        title: 'ICT in Teaching and Learning- July 2020',
        url: '/nd2_ntr20_ed22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. K. James Mathai',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-26T18:30:00.000000Z',
        endDate: '2020-08-21T17:30:00.000000Z',
        examDate: '2020-11-14T03:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed22/cf207b25353827.57474c941c85a.gif',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training \u0026 Research, Bhopal ',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODM=',
        title: 'Image Signal Processing',
        url: '/nd1_noc20_ee83/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. A.N. Rajagopalan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'BIO_TECH', category: null },
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_7', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ee01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0NDM=',
        title: 'Immunology',
        url: '/nd1_noc20_bt43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sudip Kumar Ghosh, Prof. Agneyo Ganguly',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_6', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzg=',
        title: 'Indian Government and Politics',
        url: '/nd2_cec20_hs38/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Aijaz Ashraf Wani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-09T18:30:00.000000Z',
        endDate: '2020-10-24T18:30:00.000000Z',
        examDate: '2020-11-07T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs38/IG\u0026P.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'University of Kashmir, Srinagar',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMTU=',
        title: 'Indian Judicial System: Legal Aid and Environmental Protection',
        url: '/nd2_cec20_ge15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. (Dr.) G. B. Reddy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-26T18:30:00.000000Z',
        endDate: '2020-11-19T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Law', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/Image1.1a.png?seed=31143\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/Image1.1a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'The English and Foreign Languages University (Host University)',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FyMDI=',
        title: 'Indian Vastushastra',
        url: '/nd2_cec20_ar02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Pravesh Vyas',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T20:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T06:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ugc19_hs37/Bhartiya-Vastu1.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Shri Lal Bahadur Shastri National Sanskrit University, New Delhi-16',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2FzMDQ=',
        title: 'Indian Vocal Music',
        url: '/nd2_cec20_as04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Awadhesh Pratap Singh Tomer',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-09-26T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Arts', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_as04/Music.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Dr. Harisingh Gour Vishwavidyalaya, Sagar (M.P.)',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MjE=',
        title: 'Industrial Biotechnology',
        url: '/nd1_noc20_bt21/preview',
        explorerSummary: 'Department of Biotechnology',
        explorerInstructorName: 'Prof. Debabrata Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2xiMDU=',
        title: 'Industrial Pharmacy-I',
        url: '/nd2_cec20_lb05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr Ajay Semalty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-07T18:00:00.000000Z',
        endDate: '2020-11-30T18:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-10-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_ge01/248.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'HNB Garhwal University (A Central University) Srinagar Garhwal (Uttarakhand)',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDM=',
        title: 'Industrial Safety Engineering',
        url: '/nd1_noc20_mg43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Jhareswar Maiti',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xiMDc=',
        title: 'Information Sources and Library Services',
        url: '/nd2_nou20_lb07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Archana Shukla',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-01T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lb07/Information_Sources_Library_Services.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTY=',
        title: 'Information Theory',
        url: '/nd1_noc20_ee96/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Himanshu Tyagi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_7', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjM=',
        title: 'Infrared spectroscopy for pollution monitoring',
        url: '/nd1_noc20_ch23/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. R. Mudakavi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-10-08T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTI=',
        title: 'Inkscape',
        url: '/nd2_aic20_sp12/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-13T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp12/Inkscape (1).png',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDM=',
        title: 'Innovation and Start-up Policy',
        url: '/nd2_imb20_mg43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rahul K. Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg43/ISP_Course Image.png',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'IILM Institute for Higher Education ',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X2RlMDI=',
        title: 'Innovation by Design',
        url: '/nd2_aic19_de02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. B.K. Chakravarthy ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'DESIGN_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic19_de02/InnovationbyDesign.jpg',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Industrial Design Centre, IIT Bombay ',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2RlMDg=',
        title: 'Innovation by Design',
        url: '/nd1_noc20_de08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. B.K. Chakravarthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'DESIGN_COURSES', category: null },
          { name: 'Domain_32', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_de02/IBDbanner_purpleBG.jpg',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDY=',
        title: 'Innovation, Business Models and Entrepreneurship',
        url: '/nd1_noc20_mg46/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajat Agrawal, Prof. Vinay Sharma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_32', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMzE=',
        title: 'Instructional Design',
        url: '/nd2_cec20_ge31/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr.Sajna Jaleel',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T00:00:00.000000Z',
        endDate: '2020-10-31T00:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          ' https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge31/resize Instructional Design course picture.JPG?seed=22144\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge31/resize Instructional Design course picture.JPG',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Mahatma Gandhi University, Kottayam, Kerala',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDE=',
        title: 'Integral Transforms and their Applications',
        url: '/nd1_noc20_ma41/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sarthok Sircar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDM=',
        title: 'Integrated Waste Management for a Smart City',
        url: '/nd1_noc20_ce43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Brajesh Kumar Dubey',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_19', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkNDI=',
        title: 'Integrating Educational Technology into Teaching ',
        url: '/nd2_ntr20_ed42/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. G. Janardhanan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-27T18:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-14T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed42/Final.gif',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Chennai  ',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMzA=',
        title: 'Intellectual Property',
        url: '/nd2_cec20_mg30/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Yogesh Pai',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-06T01:30:00.000000Z',
        endDate: '2020-10-24T17:30:00.000000Z',
        examDate: '2020-11-14T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg30/intellectual-property.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'National Law University, Delhi',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNDQ=',
        title: 'Intermediate Level of Spoken Sanskrit',
        url: '/nd1_noc20_hs44/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anuradha Choudry',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTI=',
        title: 'International Business',
        url: '/nd2_cec20_mg12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr.Ashwini.S',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T19:30:00.000000Z',
        endDate: '2020-09-13T17:30:00.000000Z',
        examDate: '2020-11-14T04:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg12/International Business course image.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          ' Post Graduate Department of Commerce Vidyavardhaka First Grade College, Mysore.',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTQ=',
        title: 'International Business',
        url: '/nd1_noc20_mg54/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. K. Nayak',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg08.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzNDI=',
        title: 'International Human Rights System',
        url: '/nd2_cec20_hs42/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. (Dr.) Y.S.R. Murthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          ' https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs42/resize int. human rights CP.jpg?seed=5094\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs42/resize int. human rights CP.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'O.P. Jindal Global University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMTc=',
        title: 'International Tourism Destinations ',
        url: '/nd2_cec20_ge17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sridevi Kulenur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-09-06T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge17/ITD.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Management Studies JSS CMS, SJCE Campus, JSS S\u0026TU, Mysuru',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNzk=',
        title: 'Introduction To Haskell Programming',
        url: '/nd1_noc20_cs79/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. S. P Suresh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'CMI',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODM=',
        title: 'Introduction To Japanese Language And Culture',
        url: '/nd1_noc20_hs83/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Vatsala Misra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODI=',
        title: 'Introduction To Literary Theory',
        url: '/nd1_noc20_hs82/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sayan Chattopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MjA=',
        title: 'Introduction To Proteomics',
        url: '/nd1_noc20_bt20/preview',
        explorerSummary:
          '\u003Cdiv class="yui-wk-div"\u003EDepartment of Bioscience and Bioengineering\u003Cbr\u003E\u003C/div\u003E\u003Cb\u003E\u003C/b\u003E',
        explorerInstructorName: 'Prof. Sanjeeva Srivastava',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_6', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMjk=',
        title: 'Introduction to Abstract Group Theory',
        url: '/nd1_noc20_ma29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Krishna Hanumanthu',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'Chennai Mathematical Institute',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzE=',
        title: 'Introduction to Abstract and Linear Algebra',
        url: '/nd1_noc20_ma31/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sourav Mukhopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMTI=',
        title: 'Introduction to Aerospace Engineering',
        url: '/nd1_noc20_ae12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajkumar S. Pant',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'AERO_COURSES', category: null },
          { name: 'Domain_22', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Aerospace%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMTM=',
        title: 'Introduction to Airbreathing Propulsion',
        url: '/nd1_noc20_ae13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ashoke De',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'AERO_COURSES', category: null },
          { name: 'Domain_22', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ae02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMTQ=',
        title: 'Introduction to Aircraft Design',
        url: '/nd1_noc20_ae14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajkumar S. Pant',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'AERO_COURSES', category: null },
          { name: 'Domain_22', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ae02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMTA=',
        title: 'Introduction to Ancient Indian Technology',
        url: '/nd1_noc20_ae10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D.P. Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AERO_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Aerospace%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzk=',
        title: 'Introduction to Banking and Financial Markets.',
        url: '/nd2_imb20_mg39/preview',
        explorerSummary: '',
        explorerInstructorName: 'P C Narayan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg39/PCN_IBFM_Banner 06_10_15_v1.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0Mjg=',
        title: 'Introduction to Biostatistics',
        url: '/nd1_noc20_bt28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shamik Sen',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FlMTE=',
        title: 'Introduction to CFD',
        url: '/nd1_noc20_ae11/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Arnab Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-12-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AERO_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ae02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MjI=',
        title: 'Introduction to Chemical Thermodynamics and Kinetics',
        url: '/nd1_noc20_cy22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Arijit Kumar De',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISER Mohali',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3BoMTc=',
        title: 'Introduction to Classical Mechanics',
        url: '/nd1_noc20_ph17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anurag Tripathi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Physics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ph01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Hyderbad',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lOTU=',
        title: 'Introduction to Composites',
        url: '/nd1_noc20_me95/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nachiketa Tiwari        ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2NzMTY=',
        title: 'Introduction to Computer Networks \u0026 Internet Protocols',
        url: '/nd2_cec20_cs16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Bhushan Trivedi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-02T17:30:00.000000Z',
        endDate: '2020-11-30T17:30:00.000000Z',
        examDate: '2020-12-12T17:30:00.000000Z',
        enrollmentEndDate: '2020-09-30T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'GLS University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMDI=',
        title: 'Introduction to Cyber Security',
        url: '/nd2_nou20_cs02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Jeetendra Pande',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-01T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs02/Cyber_security_course.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Uttarakhand Open University, Haldwani',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MzU=',
        title: 'Introduction to Developmental Biology',
        url: '/nd1_noc20_bt35/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Subramaniam K',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_6', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_me04.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTg=',
        title: 'Introduction to Embedded System Design',
        url: '/nd1_noc20_ee98/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Dhananjay V. Gadre, Prof. Badri Subudhi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute:
          'Netaji Subhas University of Technology, IIT Jammu',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNjE=',
        title: 'Introduction to Engineering Seismology',
        url: '/nd1_noc20_ce61/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anbazhagan P',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDg=',
        title: 'Introduction to Fuzzy Set Theory, Arithmetic and Logic',
        url: '/nd1_noc20_ma48/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Niladri Chatterjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NtMDI=',
        title: 'Introduction to GST',
        url: '/nd2_nou20_cm02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor Anirban Ghosh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Commerce', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cm01/GST.jpg',
        credits: null,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Netaji Subhas Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjk=',
        title: 'Introduction to Industry 4.0 and Industrial Internet of Things',
        url: '/nd1_noc20_cs69/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sudip Misra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs24.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNzM=',
        title: 'Introduction to Machine Learning',
        url: '/nd1_noc20_cs73/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Balaraman Ravindran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs29.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzg=',
        title: 'Introduction to Managerial Economics',
        url: '/nd2_imb20_mg38/preview',
        explorerSummary: '',
        explorerInstructorName: 'Subhashish Gupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg38/COURSE IMAGE.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzY=',
        title: 'Introduction to Marketing Essentials',
        url: '/nd2_imb20_mg36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Ashis Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg36/Marketing.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjE=',
        title: 'Introduction to Marketing Essentials',
        url: '/nd1_noc20_mg61/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Zillur Rahman',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_25', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg04.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjY=',
        title: 'Introduction to Mechanical Vibration',
        url: '/nd1_noc20_me66/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anil Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_1', category: null },
          { name: 'Domain_2', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDk=',
        title: 'Introduction to Methods of Applied Mathematics',
        url: '/nd1_noc20_ma49/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mani Mehra, Prof. Vivek K. Aggarwal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTM=',
        title: 'Introduction to Multimodal Urban Transportation Systems (MUTS)',
        url: '/nd1_noc20_ce53/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Arkopal Kishore Goswami',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ce02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNzU=',
        title: 'Introduction to Operating Systems',
        url: '/nd1_noc20_cs75/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Chester Rebeiro',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_40', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMjg=',
        title: 'Introduction to Political Theory',
        url: '/nd2_cec20_hs28/preview',
        explorerSummary: '',
        explorerInstructorName: 'DR. SIBAJI PRATIM BASU',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-31T18:30:00.000000Z',
        endDate: '2020-07-24T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-06-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs28/IMG-polsc.jpg',
        credits: 4,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'VIDYASAGAR UNIVERSITY',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMzA=',
        title: 'Introduction to Polymer Physics-IITG',
        url: '/nd1_noc20_ch30/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Amit Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MjE=',
        title: 'Introduction to Polymer Science',
        url: '/nd1_noc20_cy21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Dibakar Dhara',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cy02.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzOTE=',
        title: 'Introduction to Programming in C',
        url: '/nd1_noc20_cs91/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Satyadev Nandakumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MTk=',
        title: 'Introduction to Proteogenomics',
        url: '/nd1_noc20_bt19/preview',
        explorerSummary: 'Department of Biotechnology',
        explorerInstructorName: 'Prof. Sanjeeva Srivastava',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_8', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNTM=',
        title: 'Introduction to R Software',
        url: '/nd1_noc20_ma53/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shalabh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Mathematics', category: null },
          { name: 'Domain_8', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2dlMjI=',
        title: 'Introduction to Research',
        url: '/nd1_noc20_ge22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Prathap Haridoss',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Multidisciplinary', category: null },
          { name: 'Domain_21', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ge04.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMjk=',
        title: 'Introduction to Retail Management',
        url: '/nd2_imb20_mg29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Ashis Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg29/IntroductiontoRetailManagement.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjU=',
        title: 'Introduction to Smart Grid',
        url: '/nd1_noc20_ee65/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. N. P. Padhy, Prof. Premalata Jena',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMTQ=',
        title: 'Introduction to Visual Communication',
        url: '/nd2_cec20_ge14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor C.S.H.N.Murthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-09-14T18:30:00.000000Z',
        examDate: '2020-11-13T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge14/Course%20Picture.jpg?seed=91274\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge14/Course%20Picture.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Osmania University, Hyderabad',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNjE=',
        title: 'Introduction to Western Political Thought',
        url: '/nd1_noc20_hs61/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mithilesh Kumar Jha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs07.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjE=',
        title: 'Introduction to Wireless and Cellular Communications',
        url: '/nd1_noc20_ee61/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. R. David Koilpillai',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_7', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X2VkMjg=',
        title: 'Introduction to Yoga and Applications of Yoga',
        url: '/nd2_aic19_ed28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Sridhar Melukote ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-01-11T18:30:00.000000Z',
        endDate: '2020-04-11T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Education', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic19_ed28/newcourse.jpg',
        credits: null,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Swami Vivekananda Yoga Anusandhana Samsthan',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzOTM=',
        title: 'Introduction to algorithms and analysis',
        url: '/nd1_noc20_cs93/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sourav Mukhopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs10.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjY=',
        title: 'Introduction to internet of things',
        url: '/nd1_noc20_cs66/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sudip Misra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_40', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs22.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0Mjc=',
        title: 'Introduction to mechanobiology',
        url: '/nd1_noc20_bt27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shamik Sen',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_4', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2RlMTE=',
        title: 'Introduction to robotics',
        url: '/nd1_noc20_de11/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Asokan T, Prof. Balaraman Ravindran, Prof. Krishna Vasudevan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'DESIGN_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Design%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTU=',
        title: 'Introductory Neuroscience \u0026 Neuro-Instrumentation',
        url: '/nd1_noc20_ee95/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mahesh Jayachandra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MzA=',
        title: 'Introductory Organic Chemistry I',
        url: '/nd1_noc20_cy30/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Neeraja Dashaputre, Prof. Harinath Chakrapani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IISER Pune',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjM=',
        title: 'Ironmaking and Steelmaking',
        url: '/nd1_noc20_mm23/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Gour Gopal Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'METALLURGY_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mm02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FnMDQ=',
        title: 'Irrigation and Drainage',
        url: '/nd1_noc20_ag04/preview',
        explorerSummary:
          '\u003Cspan class="yui-tag-span yui-tag" tag="span" style="background-color: rgb(0, 0, 191);"\u003E\u003Cbr\u003E\u003C/span\u003E\u003Cb\u003E\u003C/b\u003E',
        explorerInstructorName: 'Prof. Damodhara Rao Mailapalli',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Agricultural%20and%20Food%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTM=',
        title: 'Java',
        url: '/nd2_aic20_sp13/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-25T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp13/Java (1).png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNTY=',
        title: 'Java - Bengali',
        url: '/nd2_aic20_sp56/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-30T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp13/Java (1).png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNDY=',
        title: 'Java - Hindi',
        url: '/nd2_aic20_sp46/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-30T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp13/Java (1).png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNTE=',
        title: 'Java - Tamil',
        url: '/nd2_aic20_sp51/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-30T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp13/Java (1).png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTQ=',
        title: 'Java Business Application',
        url: '/nd2_aic20_sp14/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp14/Java-Business-Application.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNjM=',
        title: 'Jmol Application - 3D chemical structure viewer',
        url: '/nd2_aic20_sp63/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp63/Jmol_Application.png',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTU=',
        title: 'Joomla CMS',
        url: '/nd2_aic20_sp15/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp15/Joomla.png',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDA=',
        title: 'Knowledge Management',
        url: '/nd1_noc20_mg40/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. KBL Srivastava',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Humanities_and_Social_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTY=',
        title: 'Koha Library Management System',
        url: '/nd2_aic20_sp16/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-27T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp16/Koha-Library-Management-System.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTc=',
        title: 'LaTeX \u0026 XFig - typesetting software',
        url: '/nd2_aic20_sp17/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp17/LaTeX.png',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMTc=',
        title: 'Laboratory and Workshop Based Instruction and Learning ',
        url: '/nd2_ntr20_ed17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Jagat Jyoti Mandal ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed17/laaaa.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training  and Research, Kolkata',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMTQ=',
        title: 'Laboratory and Workshop Management',
        url: '/nd2_ntr20_ed14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Dipankar Bose',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-14T17:30:00.000000Z',
        enrollmentEndDate: '2020-07-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed14/LAWM.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Kolkata ',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDM=',
        title: 'Laplace Transform',
        url: '/nd1_noc20_ma43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Indrava Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ma03.jpg',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IMSC',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MTc=',
        title: 'Laser: Fundamentals and Applications',
        url: '/nd1_noc20_cy17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Manabendra Chandra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDE=',
        title: 'Leadership',
        url: '/nd1_noc20_mg41/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Kalyan Chakravarti, Prof. Tuheena Mukherjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/b.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODk=',
        title: 'Learning Analytics Tools',
        url: '/nd1_noc20_cs89/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Ramkumar Rajendran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Multidisciplinary', category: null },
          { name: 'Domain_15', category: null },
          { name: 'Domain_21', category: null },
          { name: 'Domain_20', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjE5X2VkMTk=',
        title: 'Learning Management System _ MOODLE',
        url: '/nd2_ntr19_ed19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. V. Shanmuganeethi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-20T18:30:00.000000Z',
        examDate: '2020-11-14T08:30:00.000000Z',
        enrollmentEndDate: '2020-08-10T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Education', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr19_ed19/lms.gif',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute for Technical Teachers Training and Research, Chennai',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMzM=',
        title: 'Learning and Instruction',
        url: '/nd2_ntr20_ed33/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Kiran Saksena',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-18T17:30:00.000000Z',
        examDate: '2020-11-14T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed33/Li.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Bhopal ',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xiMDU=',
        title: 'Library Automation and Digitisation',
        url: '/nd2_nou20_lb05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor Uma Kanjilal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-01T17:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Library_and_Information_Sciences', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lb05/Library_automation_digitization.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTg=',
        title: 'LibreOffice Suite Base',
        url: '/nd2_aic20_sp18/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp18/LibreOffice-Suite-Base.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMTk=',
        title: 'LibreOffice Suite Calc',
        url: '/nd2_aic20_sp19/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp19/LibreOffice-Suite-Calc_.png',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjA=',
        title: 'LibreOffice Suite Draw',
        url: '/nd2_aic20_sp20/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp20/LibreOffice-Suite-Draw_.png',
        credits: 2,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjE=',
        title: 'LibreOffice Suite Impress',
        url: '/nd2_aic20_sp21/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp21/LibreOffice-Suite-Impress.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjI=',
        title: 'LibreOffice Suite Math',
        url: '/nd2_aic20_sp22/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp22/LibreOffice-Suite-Math.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjM=',
        title: 'LibreOffice Suite Writer',
        url: '/nd2_aic20_sp23/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp23/LibreOffice-Suite-Writer.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNTQ=',
        title: 'Linear Algebra',
        url: '/nd1_noc20_ma54/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Arbind Kumar Lal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ma01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTI=',
        title: 'Linear System Theory',
        url: '/nd1_noc20_ee92/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ramkrishna Pasumarthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_14', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjU=',
        title: 'Linux AWK',
        url: '/nd2_aic20_sp25/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-01T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'ELEC_ENGG', category: null },
          { name: 'Multidisciplinary', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp25/Linux-AWK.png',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMDU=',
        title: 'Linux BASH (shell scripting)',
        url: '/nd2_aic20_sp05/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-08T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'ELEC_ENGG', category: null },
          { name: 'Multidisciplinary', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp05/BASH (1).png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjQ=',
        title: 'Linux Operating System',
        url: '/nd2_aic20_sp24/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-27T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'ELEC_ENGG', category: null },
          { name: 'Multidisciplinary', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp24/Linux (1).png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNTU=',
        title: 'Linux Operating System - Bengali',
        url: '/nd2_aic20_sp55/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-30T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp24/Linux (1).png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNDU=',
        title: 'Linux Operating System- Hindi',
        url: '/nd2_aic20_sp45/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-30T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp24/Linux (1).png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNTA=',
        title: 'Linux Operating System- Tamil',
        url: '/nd2_aic20_sp50/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-30T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp24/Linux (1).png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjY=',
        title: 'Linux for Sys-Ads',
        url: '/nd2_aic20_sp26/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-27T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'ELEC_ENGG', category: null },
          { name: 'Multidisciplinary', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp26/Linux-for-Sys-Ads.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2dlMDc=',
        title: 'MATS-1: Anuvad Siddhant Evam Parampara',
        url: '/nd2_nou20_ge07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajendra Prasad Pandey',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ge07/MATS-1_Anuvad-Siddhant-Evem-Parampara_Course_Image.jpg',
        credits: 8,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Indira Gandhi National Open University, New Delhi',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2dlMDg=',
        title: 'MATS-2: Anuvad Prakriya Evam Kshetra',
        url: '/nd2_nou20_ge08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajendra Prasad Pandey',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ge08/MATS-2_Anuvad Prakriya Evem Kshetra_Course_Image.jpg',
        credits: 8,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Indira Gandhi National Open University, New Delhi',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NtMDQ=',
        title: 'MCO-05-Accounting for Managerial Decisions\u00a0',
        url: '/nd2_nou20_cm04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sunil Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Commerce', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cm04/decision.jpg',
        credits: 6,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTE=',
        title: 'MGP- 002 Philosophy of Gandhi',
        url: '/nd2_nou20_hs11/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D. Gopal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs11/MGP-002-Philosophy-of-Gandhi.jpg',
        credits: 4,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute:
          'Head Centre for Gandhi and Peace Studies, Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTM=',
        title: 'MGP- 004 Gandhi\u2019s Political Thought',
        url: '/nd2_nou20_hs13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D. Gopal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs13/MGP-004-Gandhi-Political-Thought_latest.jpg',
        credits: 4,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute:
          'Head Centre for Gandhi and Peace Studies, Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTA=',
        title: 'MGP-001 Gandhi: The Man and His Times',
        url: '/nd2_nou20_hs10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D. Gopal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs10/Gandhi-The-Man-and-His-Times.jpg',
        credits: 4,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute:
          'Head Centre for Gandhi and Peace Studies, Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTI=',
        title: 'MGP-003 Gandhi\u2019s Social Thought',
        url: '/nd2_nou20_hs12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D. Gopal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs12/MGP-003-Gandhi-Social-Thought.jpg',
        credits: 4,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute:
          'Head Centre for Gandhi and Peace Studies, Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xnMDE=',
        title:
          'MHD-02 : \u0906\u0927\u0941\u0928\u093f\u0915 \u0939\u093f\u0928\u094d\u0926\u0940 \u0915\u093e\u0935\u094d\u092f ',
        url: '/nd2_nou20_lg01/preview',
        explorerSummary: '',
        explorerInstructorName:
          '\u092a\u094d\u0930\u094b. \u0938\u0924\u094d\u092f\u0915\u093e\u092e',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-15T07:00:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Language', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lg01/MHD-002-ADHUNIK-HINDI-KAVITA.jpg',
        credits: 8,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute:
          '\u092a\u094d\u0930\u094b\u092b\u0947\u0938\u0930, \u0939\u093f\u0902\u0926\u0940 \u0938\u0902\u0915\u093e\u092f, \u092e\u093e\u0928\u0935\u093f\u0915\u0940 \u0935\u093f\u0926\u094d\u092f\u093e\u092a\u0940\u0920 \u090f\u0935\u0902 \u0938\u092e \u0915\u0941\u0932\u092a\u0924\u093f, \u0907\u0917\u094d\u0928\u0942',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2xnMDI=',
        title:
          'MHD-03 : \u0909\u092a\u0928\u094d\u092f\u093e\u0938 \u090f\u0935\u0902 \u0915\u0939\u093e\u0928\u0940',
        url: '/nd2_nou20_lg02/preview',
        explorerSummary: '',
        explorerInstructorName:
          '\u092a\u094d\u0930\u094b. \u091c\u093f\u0924\u0947\u0928\u094d\u0926\u094d\u0930 \u0915\u0941\u092e\u093e\u0930 \u0936\u094d\u0930\u0940\u0935\u093e\u0938\u094d\u0924\u0935',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Language', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_lg02/MHD-003-UPANAYAS-EVAM-KAHANIYA.jpg',
        credits: 8,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMTM=',
        title: 'MOLECULAR BIOLOGY',
        url: '/nd2_cec20_ma13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Nayan K. Jain ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-11-29T18:30:00.000000Z',
        examDate: '2020-12-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-29T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ma13/WhatsApp Image 2020-05-21 at 8.23.16 PM.jpeg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Life-Science,University School of Sciences, Gujarat University, Ahmedabad, India',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX21nMDI=',
        title: 'MS 2: Management of Human Resources',
        url: '/nd2_nou20_mg02/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Nayantara Padhi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-01T06:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_mg02/Course logo.jpg',
        credits: 6,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTU=',
        title: 'MSO 004. Sociology in India',
        url: '/nd2_nou20_hs15/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debal K. SinghaRoy ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs15/Sociology.jpg',
        credits: 8,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2hzMTQ=',
        title: 'MSO-003: Sociology of Development',
        url: '/nd2_nou20_hs14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debal K. SinghaRoy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_hs14/Sociology (2).jpg',
        credits: 8,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute:
          'Indira Gandhi National Open University, New Delhi',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzc=',
        title: 'Macro Economics',
        url: '/nd2_cec20_hs37/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Manasi Kurtkoti   ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T06:30:00.000000Z',
        endDate: '2020-09-20T17:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          ' https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs37/macroeconomics_THUMB.png?seed=61380\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs37/macroeconomics_THUMB.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Savitribai Phule Pune University, Pune',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjU=',
        title: 'Management Accounting',
        url: '/nd1_noc20_mg65/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anil K. Sharma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzE=',
        title: 'Management Accounting for Decision Making',
        url: '/nd2_imb20_mg31/preview',
        explorerSummary: '',
        explorerInstructorName: 'M S Narasimhan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg31/Management Accounting.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjA=',
        title: 'Management Information System',
        url: '/nd1_noc20_mg60/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Kunal Kanti Ghosh, Prof. Saini Das, Prof. Surojit Mukherjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjc=',
        title: 'Managerial Economics',
        url: '/nd1_noc20_mg67/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Trupti Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzA=',
        title: 'Managing Innovation',
        url: '/nd2_imb20_mg30/preview',
        explorerSummary: '',
        explorerInstructorName: 'Rishikesha T Krishnan and Vinay Dabholkar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb19_mg05/ManagingInnovation.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTM=',
        title: 'Managing Intellectual Property in Universities',
        url: '/nd1_noc20_hs53/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Feroz Ali',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Domain_32', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjA=',
        title: 'Managing Learning Resources ',
        url: '/nd2_ntr20_ed20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Uday Chand Kumar ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed20/MLR - CP.JPG',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Kolkata',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nMzY=',
        title: 'Managing Services',
        url: '/nd1_noc20_mg36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Jayanta Chatterjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_25', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTA=',
        title: 'Manufacturing Strategy',
        url: '/nd1_noc20_mg50/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajat Agrawal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Commerce', category: null },
          { name: 'Domain_31', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNDk=',
        title: 'Manufacturing Systems Technology I \u0026 II',
        url: '/nd1_noc20_me49/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shantanu Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNjg=',
        title: 'Marketing Management-I',
        url: '/nd1_noc20_mg68/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Jayanta Chatterjee, Prof. Shashi Shekhar Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_27', category: null },
          { name: 'Domain_25', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDk=',
        title: 'Marketing research and analysis',
        url: '/nd1_noc20_mg49/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. K. Nayak',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_25', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMTY=',
        title: 'Material Science',
        url: '/nd2_nou20_cs16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Shashank Srivastava',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs16/Course pic.jpg',
        credits: 2,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzk=',
        title: 'Mathematical Economics',
        url: '/nd2_cec20_hs39/preview',
        explorerSummary: '',
        explorerInstructorName: 'Sikha Ahmad,  Ishteyaaq Ahmad',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T04:00:00.000000Z',
        endDate: '2020-11-30T18:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-30T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs39/ME Cover Gif.gif',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Doon University, Dehradun, Uttaranchal University, Dehradun',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNTI=',
        title: 'Mathematical Finance',
        url: '/nd1_noc20_ma52/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. N. Selvaraju, Prof. Siddhartha Pratim Chakrabarty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNzk=',
        title: 'Mathematical Modeling Of Manufacturing Processes',
        url: '/nd1_noc20_hs79/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Swarup Bag',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_24', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDc=',
        title: 'Mathematical Modelling: Analysis and Applications',
        url: '/nd1_noc20_ma47/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ameeya Kumar Nayak',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-09-20T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzY=',
        title: 'Mathematical Portfolio Theory',
        url: '/nd1_noc20_ma36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Siddhartha Pratim Chakrabarty',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ma01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTA=',
        title: 'Mathematics XI Part-I',
        url: '/nd2_nce19_sc10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. T. P. Sarma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T18:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc10/math01bannermay.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTIwX3NjMDg=',
        title: 'Mathematics XI Part-II',
        url: '/nd2_nce20_sc08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. T. P. Sarma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T18:30:00.000000Z',
        endDate: '2020-10-29T17:30:00.000000Z',
        examDate: '2020-10-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce20_sc08/Mathematics XI  Part-01.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMTE=',
        title: 'Mathematics XII Part-I',
        url: '/nd2_nce19_sc11/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. T. P. Sarma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T18:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc11/mathsnew2020.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DESM, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzQ=',
        title: 'Matrix Analysis with Applications',
        url: '/nd1_noc20_ma34/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. S. K. Gupta, Prof. Sanjeev Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDE=',
        title: 'Matrix Method of Structural Analysis',
        url: '/nd1_noc20_ce41/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Amit Shaw, Prof. Biswanath Banerjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_38', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDQ=',
        title: 'Measure Theory',
        url: '/nd1_noc20_ma44/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Indrava Roy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ma02.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IMSC',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTc=',
        title: 'Mechanical Measurement Systems',
        url: '/nd1_noc20_me57/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ravi Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMzk=',
        title: 'Mechanical Operation',
        url: '/nd1_noc20_ch39/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Shabina Khanam',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjc=',
        title: 'Mechanical Unit Operations',
        url: '/nd1_noc20_ch27/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nanda Kishore',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_28', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTA=',
        title: 'Mechanics Of Materials',
        url: '/nd1_noc20_ce50/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Saravanan U',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CIVIL_ENGINEERING', category: null },
          { name: 'Domain_38', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTM=',
        title: 'Mechanism And Robot Kinematics',
        url: '/nd1_noc20_me53/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anirvan DasGupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MjY=',
        title: 'Mechanisms in Organic Chemistry',
        url: '/nd1_noc20_cy26/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nandita Madhavan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMzI=',
        title: 'Media Content Production on Multiple Platforms ',
        url: '/nd2_cec20_ge32/preview',
        explorerSummary: '',
        explorerInstructorName: 'Krishna Sankar Kusuma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-01T00:00:00.000000Z',
        endDate: '2020-11-29T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T23:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ugc19_hs42/1.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Jamia Millia Islamia',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2dlMDk=',
        title: 'Media, Information and Empowerment',
        url: '/nd2_nou20_ge09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. K. S. Arul Selvan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_ge09/Media Information Empowerment.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5Mjk=',
        title: 'Metals in Biology',
        url: '/nd1_noc20_cy29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. D. Maiti',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MTQ=',
        title: 'Microbial Physiology and metabolism',
        url: '/nd2_cec20_bt14/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. RAGHAVENDRA M.P.',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T19:30:00.000000Z',
        endDate: '2020-09-13T17:30:00.000000Z',
        examDate: '2020-11-14T04:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt14/MICROBIAL PHYSIOLOGY AND METABOLISM course image.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          '  Maharani\u2019s Science College for Women, Mysuru-570 005',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODU=',
        title: 'Microelectronics: Devices To Circuits',
        url: '/nd1_noc20_ee85/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sudeb Dasgupta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_14', category: null },
          { name: 'Domain_41', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTE=',
        title: 'Microwave Engineering',
        url: '/nd1_noc20_ee91/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ratnajit Bhattacharjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_33', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNjM=',
        title: 'Microwave Theory and Techniques',
        url: '/nd1_noc20_ee63/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Girish Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzE=',
        title: 'Millimeter Wave Technology',
        url: '/nd1_noc20_ee71/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mrinal Kanti Mandal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzE5X2FzMDU=',
        title: 'Mind Education',
        url: '/nd2_aic19_as05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Kim Soo Yeon',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Arts', category: null },
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Education', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic19_as05/4617_large.jpg',
        credits: null,
        weeks: null,
        nodeCode: 'nd2',
        instructorInstitute: 'International Youth Fellowship ',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODQ=',
        title: 'Modern Indian Art From the Colonial Period to the Present',
        url: '/nd1_noc20_hs84/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Soumik Nandy Majumdar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs02.jpg',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'Visva Bharati University, Santiniketan',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjc=',
        title: 'Moodle Learning Management System',
        url: '/nd2_aic20_sp27/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-02T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp27/Moodle-Learning-Management-System.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTY=',
        title: 'Municipal Solid Waste Management',
        url: '/nd1_noc20_ce56/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ajay Kalamdhad',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ce01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0NDE=',
        title: 'Nanotechnology in Agriculture',
        url: '/nd1_noc20_bt41/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mainak Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjQ=',
        title: 'Natural Gas Engineering',
        url: '/nd1_noc20_ch24/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Pankaj Tiwari',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMjg=',
        title: 'Netbeans',
        url: '/nd2_aic20_sp28/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp28/NetBeans.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2dlMTc=',
        title: 'Neuroscience of Human Movements',
        url: '/nd1_noc20_ge17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Varadhan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Multidisciplinary/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMjg=',
        title: 'New Product Development',
        url: '/nd2_imb20_mg28/preview',
        explorerSummary: '',
        explorerInstructorName: 'Ganesh N Prabhu',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg28/Course_Banner_original.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNTU=',
        title: 'Non-parametric Statistical Inference',
        url: '/nd1_noc20_ma55/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Niladri Chatterjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3BoMTk=',
        title: 'Nuclear and Particle Physics',
        url: '/nd1_noc20_ph19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Poulose Poulose',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Physics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Physics/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMTg=',
        title: 'Numerical Analysis',
        url: '/nd2_cec20_ma18/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Madhumangal Pal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T00:30:00.000000Z',
        endDate: '2021-01-31T17:30:00.000000Z',
        examDate: '2020-11-15T17:30:00.000000Z',
        enrollmentEndDate: '2020-11-30T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          ' https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/Image0.1.png?seed=65663\u0026url=https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/Image0.1.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Vidyasagar University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3BoMjM=',
        title:
          'Numerical Methods And Simulation Techniques For Scientists And Engineers',
        url: '/nd1_noc20_ph23/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Saurabh Basu',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Physics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Physics/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2dlMjA=',
        title: 'Numerical Methods for Engineers',
        url: '/nd1_noc20_ge20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Niket Kaisare',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Multidisciplinary', category: null },
          { name: 'Domain_2', category: null },
          { name: 'Domain_9', category: null },
          { name: 'Domain_10', category: null },
          { name: 'Domain_11', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Multidisciplinary/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzM=',
        title: 'Numerical methods',
        url: '/nd1_noc20_ma33/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ameeya Kumar Nayak, Prof. Sanjeev Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Mathematics', category: null },
          { name: 'Domain_12', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkNDA=',
        title: 'OER for Empowering Teachers',
        url: '/nd2_ntr20_ed40/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. P. Malliga ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-26T18:30:00.000000Z',
        endDate: '2020-08-21T17:30:00.000000Z',
        examDate: '2020-11-14T03:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed40/oer.jpg',
        credits: 2,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Chennai ',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNTk=',
        title: 'Object Oriented Analysis and Design',
        url: '/nd1_noc20_cs59/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Partha Pratim Das, Prof. Ansuman Banerjee, Prof. Kausik Datta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODQ=',
        title:
          'Object Oriented System Development using UML, Java and Patterns',
        url: '/nd1_noc20_cs84/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rajib Mall',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MzY=',
        title: 'One and two dimensional NMR Spectroscopy for chemists',
        url: '/nd1_noc20_cy36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. N. Suryaprakash',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNTU=',
        title:
          'Op-Amp Practical Applications: Design, Simulation and Implementation',
        url: '/nd1_noc20_ee55/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Hardik Jeetendra Pandya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISc Bangalore',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMzA=',
        title: 'OpenModelica',
        url: '/nd2_aic20_sp30/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-22T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'MECH_ENGG', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp30/OpenModelica (1).png',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMTk=',
        title: 'Operations Research',
        url: '/nd2_cec20_ma19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Professor Bibhas C. Giri',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Jadavpur University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNDU=',
        title: 'Operations Research',
        url: '/nd1_noc20_ma45/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Kusumdeep',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMjA=',
        title: 'Organic Chemistry 1',
        url: '/nd2_cec20_ma20/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. B. S. Balaji',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-23T19:00:00.000000Z',
        endDate: '2020-11-30T00:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-30T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ugc19_ch01/og.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Jawaharlal Nehru University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FnMDU=',
        title: 'Organic Farming for Sustainable Agricultural Production',
        url: '/nd1_noc20_ag05/preview',
        explorerSummary: '\n',
        explorerInstructorName: 'Prof. Dillip Kumar Swain',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'AGRI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Agricultural%20and%20Food%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMzM=',
        title: 'Organisation Behaviour',
        url: '/nd2_cec20_mg33/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof.(Dr.) A.K.Saihjpal, Prof.(Dr.) Vishal Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-16T18:30:00.000000Z',
        endDate: '2020-11-30T17:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg33/OB1.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute:
          'Panjab University, Chandigarh, Maharaja Agrasen University, Baddi, Himachal Pradesh',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTY=',
        title: 'Organization Development and Change in 21st Century',
        url: '/nd1_noc20_mg56/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ashish Pandey',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_20', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg01.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTE=',
        title: 'Organizational Behaviour',
        url: '/nd1_noc20_mg51/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. M. P. Ganesh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg03.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Hyderbad',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nMzc=',
        title: 'Organizational Design: Creating Competitive Advantage',
        url: '/nd2_imb20_mg37/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sourav Mukherji',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T06:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb19_mg15/DesigningOrganizationsforCompetitiveAdvantage.png',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMzE=',
        title: 'PERL',
        url: '/nd2_aic20_sp31/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-08T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp31/Perl (1).png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMzI=',
        title: 'PHP and MySQL',
        url: '/nd2_aic20_sp32/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-08T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp32/PHP-MySQL.png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MTM=',
        title: 'PLANT PATHOLOGY AND SOIL HEALTH',
        url: '/nd2_cec20_bt13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Vindhya K',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-06-14T20:00:00.000000Z',
        endDate: '2020-08-30T18:00:00.000000Z',
        examDate: '2020-11-14T05:00:00.000000Z',
        enrollmentEndDate: '2020-07-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt13/PPASH.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'MAHARANI\u2019S SCIENCE COLLEGE FOR WOMEN',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21hMjE=',
        title: 'Partial Differential Equations',
        url: '/nd2_cec20_ma21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Alaka Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-05T18:30:00.000000Z',
        endDate: '2020-11-29T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl: '',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Jadavpur University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTQ=',
        title: 'Patent Drafting for Beginners',
        url: '/nd1_noc20_hs54/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Feroz Ali',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-10-09T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Law', category: null },
          { name: 'Domain_20', category: null },
          { name: 'Domain_32', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs25.jpg',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNTU=',
        title: 'Patent Law for Engineers and Scientists',
        url: '/nd1_noc20_hs55/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Feroz Ali',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Law', category: null },
          { name: 'Domain_32', category: null },
          { name: 'Domain_20', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs26.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODk=',
        title: 'Patent Search for Engineers and Lawyers',
        url: '/nd1_noc20_hs89/preview',
        explorerSummary: 'Department of Rajiv Gandhi School of IP Law',
        explorerInstructorName: 'Prof. M. Padmavati, Prof. Shreya Matilal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Humanities_and_Social_Sciences', category: null },
          { name: 'Law', category: null },
          { name: 'Domain_32', category: null },
        ],
        tags: [],
        featured: false,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur, IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTU=',
        title: 'Path Integral Methods in Physics \u0026 Finance',
        url: '/nd1_noc20_mg55/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. P. Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Physics', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg08.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTIwX3NjMDQ=',
        title: 'Pedagogy of Environmental Studies',
        url: '/nd2_nce20_sc04/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Kavita Sharma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-01T05:30:00.000000Z',
        endDate: '',
        examDate: '2021-01-03T07:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce20_sc04/28_covid.png',
        credits: 2,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'DEE, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzg=',
        title: 'Peer To Peer Networks',
        url: '/nd1_noc20_ee78/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Y. N. Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ee01.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNjU=',
        title: 'PhETs - Interactive Simulations for Science and Math',
        url: '/nd2_aic20_sp65/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp65/PheT.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMjI=',
        title: 'Phase equilibrium thermodynamics',
        url: '/nd1_noc20_ch22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Gargi Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNjA=',
        title: 'Photogeology in Terrain Evaluation (Part 1 and 2)',
        url: '/nd1_noc20_ce60/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Javed N. Malik',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMTc=',
        title: 'Physics Of Materials',
        url: '/nd1_noc20_mm17/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Prathap Haridoss',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'METALLURGY_COURSES', category: null },
          { name: 'Domain_16', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Metallurgy%20and%20Material%20Science/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMDU=',
        title: 'Physics XI Part-I',
        url: '/nd2_nce19_sc05/preview',
        explorerSummary: '',
        explorerInstructorName: 'Anuradha Mathur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc05/physics 01.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'CIET, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMDY=',
        title: 'Physics XI Part-II',
        url: '/nd2_nce19_sc06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Anuradha Mathur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc06/physics 02.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'CIET, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMDc=',
        title: 'Physics XII Part-I',
        url: '/nd2_nce19_sc07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Anuradha Mathur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc07/physics 03.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'CIET, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMDg=',
        title: 'Physics XII Part-II',
        url: '/nd2_nce19_sc08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Anuradha Mathur',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T00:00:00.000000Z',
        examDate: '2020-10-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T00:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc08/physics 04.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'CIET, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2J0MTk=',
        title: 'Physiology and Biochemistry',
        url: '/nd2_cec20_bt19/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Ramtej J. Verma',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T18:30:00.000000Z',
        endDate: '2020-10-04T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'BIO_TECH', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_bt19/WhatsApp Image 2020-05-22 at 5.57.36 PM.jpeg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of zoology, biomedical technology and human genetics,Gujarat University',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MzQ=',
        title: 'Plant Cell Bioprocessing',
        url: '/nd1_noc20_bt34/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Smita Srivastava',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_5', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoMzE=',
        title: 'Plant Design and Economics',
        url: '/nd1_noc20_ch31/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Debasis Sarkar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'CHEMICAL_COURSES', category: null },
          { name: 'Domain_29', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ch03.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MzY=',
        title: 'Plant Developmental Biology',
        url: '/nd1_noc20_bt36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Shri Ram Yadav',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-10-08T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_6', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNjQ=',
        title: 'Poetry',
        url: '/nd1_noc20_hs64/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. S P Dhanavel',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_hs04.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMzY=',
        title: 'Political Ideologies',
        url: '/nd2_cec20_hs36/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Wahida Shaikh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-20T06:30:00.000000Z',
        endDate: '2020-09-27T17:30:00.000000Z',
        examDate: '2020-11-15T03:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs36/Political Ideologies-course Image.png',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Savitribai Phule Pune University, Pune',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMTM=',
        title: 'Pollutants and Water Supply',
        url: '/nd2_nou20_cs13/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Anuj Kumar Purwar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs13/Pollutants and water supply.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NoNDE=',
        title: 'Polymers: concepts, properties, uses and sustainability',
        url: '/nd1_noc20_ch41/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Abhijit P Deshpande',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CHEMICAL_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Chemical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzNjI=',
        title: 'Postmodernism in Literature',
        url: '/nd1_noc20_hs62/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Merin Simi Raj',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21tMjE=',
        title: 'Powder Metallurgy',
        url: '/nd1_noc20_mm21/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ranjit Bauri',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'METALLURGY_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_mm21/Powder.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlOTc=',
        title: 'Power Electronics',
        url: '/nd1_noc20_ee97/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. G.Bhuvaneshwari',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_34', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzM=',
        title: 'Power System Protection',
        url: '/nd1_noc20_ee73/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ashok Kumar Pradhan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_34', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ee51.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODA=',
        title: 'Power System Protection and Switchgear',
        url: '/nd1_noc20_ee80/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Bhaveshkumar R. Bhalja',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_bt17.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNzI=',
        title: 'Power system analysis',
        url: '/nd1_noc20_ee72/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debapriya Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'ELEC_ENGG', category: null },
          { name: 'Domain_34', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzOTU=',
        title: 'Practical Machine Learning with Tensorflow',
        url: '/nd1_noc20_cs95/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Ashish Tendulkar, Prof. Balaraman Ravindran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/c.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'Google, IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDE=',
        title: 'Predictive Analytics',
        url: '/nd2_imb20_mg41/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dinesh Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T04:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T21:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg41/bannerimage.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore (IIMB)',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzc=',
        title: 'Principle of Hydraulic Machines and System Design',
        url: '/nd1_noc20_me77/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Pranab K. Mondal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2J0MjU=',
        title: 'Principles Of Downstream Techniques In Bioprocess',
        url: '/nd1_noc20_bt25/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mukesh Doble',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'BIO_TECH', category: null },
          { name: 'Domain_5', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Biological%20Sciences%20%26%20Bioengineering/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MzQ=',
        title: 'Principles Of Organic Synthesis',
        url: '/nd1_noc20_cy34/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. T Punniyamurthy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-19T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMTY=',
        title: 'Principles and applications of building science',
        url: '/nd1_noc20_ar16/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. E. Rajasekar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Architecture%20and%20Planning/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3RlMTA=',
        title: 'Principles of Combing,Roving preparation \u0026 Ring spinning',
        url: '/nd1_noc20_te10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. R. Chattopadhyay',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEXTILE_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Textile%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMTA=',
        title: 'Principles of Electrical Sciences',
        url: '/nd2_nou20_cs10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Sanjay Agrawal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs10/Principle_of_electrical_sciences.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2hzMjY=',
        title: 'Principles of Macroeconomics-I',
        url: '/nd2_cec20_hs26/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Kamlesh Gakhar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-01T18:00:00.000000Z',
        endDate: '2020-09-30T18:00:00.000000Z',
        examDate: '2020-11-15T00:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs26/couse image.jpg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Maharshi Dayanand University, Rohtak',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNTg=',
        title: 'Principles of Management',
        url: '/nd1_noc20_mg58/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Susmita Mukhopadhyay, Prof. S. Srinivasan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Management', category: null },
          { name: 'Domain_27', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_mg01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzI=',
        title: 'Principles of Metal Forming Technology',
        url: '/nd1_noc20_me72/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Pradeep Kumar Jha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlNTg=',
        title:
          'Principles of Signal Estimation for MIMO/ OFDM Wireless Communication',
        url: '/nd1_noc20_ee58/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Aditya K. Jagannatham',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Electrical%2C%20Electronics%20and%20Communications%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNDg=',
        title: 'Principles of Vibration Control',
        url: '/nd1_noc20_me48/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Bishakh Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2VlODI=',
        title: 'Probability Foundations for Electrical Engineers',
        url: '/nd1_noc20_ee82/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Krishna Jagannathan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ELEC_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ee01.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjk=',
        title: 'Problem Based Learning ',
        url: '/nd2_ntr20_ed29/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Indrajit Saha',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-10T18:30:00.000000Z',
        examDate: '2020-11-15T17:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed29/PBL.gif',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute of Technical Teachers Training and Research, Kolkata',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNTY=',
        title: 'Problem solving through Programming In C',
        url: '/nd1_noc20_cs56/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Anupam Basu',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs06.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNjk=',
        title: 'Product Design and Development',
        url: '/nd1_noc20_me69/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Inderdeep Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_35', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMDc=',
        title: 'Production Management',
        url: '/nd2_nou20_cs07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Ashish Agarwal',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs07/Course Cover Image.jpg',
        credits: 4,
        weeks: 16,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2xnMDY=',
        title: 'Proficiency Course in French   ',
        url: '/nd2_cec20_lg06/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nirupama Rastogi (Rtd)',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-06T00:00:00.000000Z',
        endDate: '2020-11-20T00:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-29T23:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Language', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_lg04/PCF-LOGO.jpg',
        credits: 5,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'The English and Foreign Languages University, Hyderabad',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2xnMDg=',
        title: 'Proficiency Course in Russian',
        url: '/nd2_cec20_lg08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Pusp Ranjan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-06T00:00:00.000000Z',
        endDate: '2020-11-20T18:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-30T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Language', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_lg05/PCR-LOGO.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'The English and Foreign Languages University, Lucknow Campus',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2xnMDc=',
        title: 'Proficiency Course in Spanish',
        url: '/nd2_cec20_lg07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. T. Srivani',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-06T00:00:00.000000Z',
        endDate: '2020-11-20T18:00:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-09-30T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Language', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec19_lg03/PCS-LOGO.jpg',
        credits: 5,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute:
          'The English and Foreign Languages University, Hyderabad',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNTc=',
        title: 'Programming in C++',
        url: '/nd1_noc20_cs57/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Partha Pratim Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs07.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNTg=',
        title: 'Programming in Java',
        url: '/nd1_noc20_cs58/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Debasis Samanta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_36', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs08.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNzA=',
        title: 'Programming, Data Structures And Algorithms Using Python',
        url: '/nd1_noc20_cs70/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Madhavan Mukund',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_36', category: null },
          { name: 'Domain_15', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_23', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs26.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'Chennai Mathematical Institute',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDQ=',
        title: 'Project Planning \u0026 Control',
        url: '/nd1_noc20_ce44/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Koshy Varghese',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21nNDg=',
        title: 'Project management for managers',
        url: '/nd1_noc20_mg48/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Mukesh Kumar Barua',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'Commerce', category: null },
          { name: 'Domain_31', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Management%20Studies/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMjI=',
        title: 'Psychology XI Part-I',
        url: '/nd2_nce19_sc22/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Prabhat K. Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-15T00:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc22/psychology01may2020.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DEPFE, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTIwX3NjMTA=',
        title: 'Psychology XI Part-II',
        url: '/nd2_nce20_sc10/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Prabhat K. Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T19:30:00.000000Z',
        endDate: '2020-10-29T17:30:00.000000Z',
        examDate: '2020-10-15T17:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce20_sc10/Psychology XI  Part-01.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DEPFE, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25jZTE5X3NjMjM=',
        title: 'Psychology XII Part-I',
        url: '/nd2_nce19_sc23/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Prabhat K. Mishra',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-05-14T20:00:00.000000Z',
        endDate: '2020-10-29T18:00:00.000000Z',
        examDate: '2020-10-15T18:00:00.000000Z',
        enrollmentEndDate: '2020-08-15T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'SCHOOL', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nce19_sc23/psy 03.png',
        credits: 2,
        weeks: 24,
        nodeCode: 'nd2',
        instructorInstitute: 'DEPFE, NCERT, New Delhi',
        ncCode: 'NCERT',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMzM=',
        title: 'Python 3.4.3',
        url: '/nd2_aic20_sp33/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-28T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp33/Python3.4.3 (1).png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwNDQ=',
        title: 'Python 3.4.3 - Hindi',
        url: '/nd2_aic20_sp44/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-30T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp33/Python3.4.3 (1).png',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzODA=',
        title: 'Python for Data Science',
        url: '/nd1_noc20_cs80/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ragunathan Rengasamy',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cs36.jpg',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX25vdTIwX2NzMTI=',
        title: 'Quality Engineering \u0026 Management',
        url: '/nd2_nou20_cs12/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. N.Venkateshwarlu',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-14T18:30:00.000000Z',
        endDate: '2020-10-30T18:30:00.000000Z',
        examDate: '',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/nou20_cs12/quality engineering management.jpg',
        credits: 4,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indira Gandhi National Open University',
        ncCode: 'IGNOU',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2ltYjIwX21nNDQ=',
        title: 'Quantitative Marketing Research',
        url: '/nd2_imb20_mg44/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prithwiraj Mukherjee',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-27T01:00:00.000000Z',
        endDate: '2020-10-31T18:00:00.000000Z',
        examDate: '2020-11-14T19:00:00.000000Z',
        enrollmentEndDate: '2020-08-31T18:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/imb20_mg44/QTM BANNER.jpg',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Management Bangalore',
        ncCode: 'IIMB',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX21nMTg=',
        title: 'Quantitative Techniques for Management',
        url: '/nd2_cec20_mg18/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. Manharlala N. Patel ',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-08-02T18:30:00.000000Z',
        endDate: '2020-10-28T18:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-30T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Management', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_mg18/WhatsApp Image 2020-05-23 at 10.36.30 PM.jpeg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'Department of Statistics, University School of Sciences, Gujarat University, Ahmedabad, India.',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5Mjc=',
        title: 'Quantum Chemistry of Atoms and Molecules',
        url: '/nd1_noc20_cy27/preview',
        explorerSummary: null,
        explorerInstructorName: 'Prof. Anindya Datta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_cy05.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MzE=',
        title: 'Quantum Mechanics and Molecular Spectroscopy',
        url: '/nd1_noc20_cy31/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. G Naresh Patwari',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Bombay',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkNDM=',
        title: 'Question Paper Authoring and Student Evaluation',
        url: '/nd2_ntr20_ed43/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. V. Shanmuganeethi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-30T18:30:00.000000Z',
        endDate: '2020-09-28T17:30:00.000000Z',
        examDate: '2020-11-15T08:30:00.000000Z',
        enrollmentEndDate: '2020-08-15T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed43/Studenrt Assesssment.gif',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute for Technical Teachers Training and Research, Chennai',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMzU=',
        title: 'R    ',
        url: '/nd2_aic20_sp35/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-03-28T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [
          { name: 'Multidisciplinary', category: null },
          { name: 'Mathematics', category: null },
          { name: 'Applied_Sciences', category: null },
          { name: 'Management', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp35/R (1).png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMzY=',
        title: 'RDBMS PostgreSQL',
        url: '/nd2_aic20_sp36/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-21T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp36/RDBMS.png',
        credits: 2,
        weeks: 6,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTA=',
        title: 'Rapid Manufacturing',
        url: '/nd1_noc20_me50/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. J. Ramkumar, Prof. Amandeep Singh',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'MECH_ENGG', category: null },
          { name: 'Domain_24', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/c.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kanpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2N5MzU=',
        title: 'Reagents In Organic Synthesis',
        url: '/nd1_noc20_cy35/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Subhas Chandra Pan',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-12-03T19:00:00.000000Z',
        examDate: '2020-12-18T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Chemistry', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Basic%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hNTE=',
        title: 'Real Analysis I',
        url: '/nd1_noc20_ma51/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Jaikrishnan J',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ma03.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Palakkad',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNzE=',
        title: 'Refrigeration and air-conditioning',
        url: '/nd1_noc20_me71/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Ravi Kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21hMzA=',
        title: 'Regression Analysis',
        url: '/nd1_noc20_ma30/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Soumen Maity',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Mathematics', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mathematics/d.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IISER Pune',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNDA=',
        title: 'Reinforced Concrete Road Bridges',
        url: '/nd1_noc20_ce40/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Nirjhar Dhang',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-10-08T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/a.png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNzQ=',
        title: 'Reinforcement Learning',
        url: '/nd1_noc20_cs74/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Balaraman Ravindran',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-12-03T18:30:00.000000Z',
        examDate: '2020-12-19T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [
          { name: 'COMP_SCI_ENGG', category: null },
          { name: 'Domain_3', category: null },
          { name: 'Domain_15', category: null },
        ],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Madras',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTg=',
        title: 'Remote Sensing and GIS',
        url: '/nd1_noc20_ce58/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Rishikesh Bharti',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Civil%20Engineering/d.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMzM=',
        title: 'Research Ethics',
        url: '/nd2_cec20_ge33/preview',
        explorerSummary: '',
        explorerInstructorName: 'Shri Manoj Kumar K',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-12T19:00:00.000000Z',
        endDate: '2020-10-25T18:00:00.000000Z',
        examDate: '2020-11-14T04:00:00.000000Z',
        enrollmentEndDate: '2020-08-30T23:00:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_ge33/download.jpeg',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'Central University of Himachal Pradesh',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2NlYzIwX2dlMzc=',
        title: 'Research Methodology',
        url: '/nd2_cec20_ge37/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. G.S.Bajpai',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-06T02:30:00.000000Z',
        endDate: '2020-10-31T17:30:00.000000Z',
        examDate: '2020-11-14T18:30:00.000000Z',
        enrollmentEndDate: '2020-08-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/cec20_hs17/800px-7Ps_of_Research_Design.jpg ',
        credits: 4,
        weeks: 15,
        nodeCode: 'nd2',
        instructorInstitute: 'National Law University, Delhi',
        ncCode: 'CEC',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX250cjIwX2VkMjY=',
        title: 'Research in Technical Education ',
        url: '/nd2_ntr20_ed26/preview',
        explorerSummary: '',
        explorerInstructorName: 'Dr. P. K. Tulsi',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-07-19T18:30:00.000000Z',
        endDate: '2020-09-11T17:30:00.000000Z',
        examDate: '2020-11-14T03:30:00.000000Z',
        enrollmentEndDate: '2020-07-31T17:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEACHER_EDUCATION', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/ntr20_ed26/Research in technical Education.jpg',
        credits: 3,
        weeks: 8,
        nodeCode: 'nd2',
        instructorInstitute:
          'National Institute Of Technical Teachers Training And Research, Chandigarh',
        ncCode: 'NITTTR',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2x3MDE=',
        title: 'Right to Information and Good Governance',
        url: '/nd1_noc20_lw01/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sairam Bhat',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-19T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Law', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/assets/img/noc20_lw01/rsz_shutterstock_652306210.jpg',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'National Law School of India University',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NlNTQ=',
        title: 'River Engineering',
        url: '/nd1_noc20_ce54/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Subashisa Dutta',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-18T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'CIVIL_ENGINEERING', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam2-node/Jan%202020%20Course%20card%20images/noc20_ce02.jpg',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX21lNTY=',
        title: 'Robotics',
        url: '/nd1_noc20_me56/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Dilip Kumar Pratihar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-11-06T00:00:00.000000Z',
        examDate: '2020-12-18T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'MECH_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Mechanical%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Kharagpur',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2FyMDk=',
        title: 'Role of Craft and Technology in Interior - Architecture',
        url: '/nd1_noc20_ar09/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Smriti Saraswat',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T19:00:00.000000Z',
        endDate: '2020-11-05T19:00:00.000000Z',
        examDate: '2020-12-17T19:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'ARCHI_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Architecture%20and%20Planning/a.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Roorkee',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQyX2FpYzIwX3NwMzc=',
        title: 'Ruby',
        url: '/nd2_aic20_sp37/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof Kannan Moudgalya - Principal Investigator of Spoken Tutorial Project',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-04-24T04:30:00.000000Z',
        endDate: '',
        examDate: '',
        enrollmentEndDate: '',
        estimatedWorkload: null,
        category: [{ name: 'Multidisciplinary', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node2-production.appspot.com/assets/img/aic20_sp37/Ruby (1).png',
        credits: 1,
        weeks: 4,
        nodeCode: 'nd2',
        instructorInstitute: 'Indian Institute of Technology Bombay',
        ncCode: 'AICTE',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2NzNjE=',
        title: 'Scalable Data Science',
        url: '/nd1_noc20_cs61/preview',
        explorerSummary: '',
        explorerInstructorName:
          'Prof. Anirban Dasgupta, Prof. Sourangshu Bhattacharya',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T18:30:00.000000Z',
        endDate: '2020-11-05T18:30:00.000000Z',
        examDate: '2020-12-17T18:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'COMP_SCI_ENGG', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Computer%20Science%20and%20Engineering/b.png',
        credits: 2,
        weeks: 8,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Gadhinagar',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3RlMDg=',
        title: 'Science and Technology of Weft and Warp Knitting',
        url: '/nd1_noc20_te08/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Bipin kumar',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-20T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEXTILE_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Textile%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX3RlMDc=',
        title: 'Science of Clothing Comfort',
        url: '/nd1_noc20_te07/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Apurba Das',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-14T00:00:00.000000Z',
        endDate: '2020-12-04T00:00:00.000000Z',
        examDate: '2020-12-19T00:00:00.000000Z',
        enrollmentEndDate: '2020-09-20T18:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'TEXTILE_COURSES', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Textile%20Engineering/b.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Delhi',
        ncCode: 'NPTEL',
      },
    },
    {
      node: {
        id: 'Q291cnNlTGlzdDovbmQxX25vYzIwX2hzODU=',
        title: 'Science, Technology and Society',
        url: '/nd1_noc20_hs85/preview',
        explorerSummary: '',
        explorerInstructorName: 'Prof. Sambit Mallick',
        enrollment: { enrolled: false },
        openForRegistration: true,
        availability: 'registration_required',
        showInExplorer: true,
        startDate: '2020-09-13T23:30:00.000000Z',
        endDate: '2020-12-03T23:30:00.000000Z',
        examDate: '2020-12-18T23:30:00.000000Z',
        enrollmentEndDate: '2020-09-20T23:30:00.000000Z',
        estimatedWorkload: null,
        category: [{ name: 'Humanities_and_Social_Sciences', category: null }],
        tags: [],
        featured: true,
        coursePictureUrl:
          'https://storage.googleapis.com/swayam-node1-production.appspot.com/July%202019%20Course%20images/Cards_ShutterStockImages_250x90/Humanities%20and%20Social%20Sciences/a.png',
        credits: 3,
        weeks: 12,
        nodeCode: 'nd1',
        instructorInstitute: 'IIT Guwahati',
        ncCode: 'NPTEL',
      },
    },
  ],
};
